<template>
<div class="con-sa" id="style-3">
    <!-- Popup temporaneo Arrivato (3 secondi) in alto a sinistra -->
    <transition name="fade">
        <div v-if="popupArrivato" class="badge-tavolo-arrivato-fixed" @click="popupArrivato = null" title="Clicca per chiudere">
            <i class="fas fa-check-circle me-1"></i>ARRIVATO <span v-if="popupArrivato.tavolo" class="ms-1">T{{ popupArrivato.tavolo }}</span>
        </div>
    </transition>

    <div class="container-calendar-main" v-if="tavolo">
        <div class="cont-info">
            <div class="pren side-column">
                <div class="cont-cal">
                    <v-date-picker v-model="date" mode="dateTime"  />
                </div>
                <div class="cont-btn-pre">
                    <div>
                        <span>{{ $t('tavolo') }} {{tavolo}}</span><br/>
                        <span>{{ $t('sala') }} {{sala}} </span>
                    </div>
                </div>

                <div class="cont-btn-pre-2" style="display: flex; gap: 10px; margin-top: 10px;">
                    <a href="#" class="btn btn-outline-success btn-sm" @click.prevent="showBookingModal = true">{{ $t('prenota_tavolo') }}</a>
                    <a href="#" class="btn btn-outline-primary btn-sm" @click.prevent="() => aggiungiPiatti(tavolo)">{{ $t('aggiungi_piatti', 'Aggiungi Piatti') }}</a>
                </div>
            </div>
            <div class="pren middle-column">
            <ul class="nav nav-tabs">
                <li class="nav-item">
                    <span class="nav-link active" :style="{'backgroundColor':tab.prenotazioni? bgActive:bgInactive}" id="prenotazioni" @click="showTab">{{ $t('prenotazioni') }}  {{ $t('sala') }} {{prenotazionisala.length}}</span>
                </li>
                <li class="nav-item" >
                    <span class="nav-link active" :style="{'backgroundColor':tab.prenT? bgActive:bgInactive}" id="pren-t" @click="showTab">{{ $t('prenotazioni') }}  {{ $t('tavolo') }}</span>
                </li>
                <li class="nav-item">
                   <span class="nav-link active" :style="{'backgroundColor':tab.ordinazioni? bgActive:bgInactive}" id ="ordini" @click="showTab">{{ $t('ordinazione') }}</span>
                </li>
            </ul>
                <div class="pano-pren" v-show="tab.ordinazioni">
                    <div class="card" >
                        <div v-if="ordinazione.length">
                            <ul class="list-group list-group-flush" v-for="ordine in ordinazione" :key="ordine.t">
                                <li class="list-group-item m" :style="isOrdinePrecedente(ordine) ? 'background: #fffbeb; border-left: 4px solid #d97706;' : ''">
                                    <div class="d-flex justify-content-between align-items-center">
                                        <span>{{ $t('tavolo') }}: <strong>{{ordine.t}}</strong>, {{ $t('giorno') }}: {{ordine.tm}}</span>
                                        <span v-if="isOrdinePrecedente(ordine)" class="badge bg-warning text-dark"><i class="fas fa-history me-1"></i>DA IERI</span>
                                    </div>
                                </li>
                                <li >{{ $t('coperti') }}: {{ordine.coperti}}</li>
                                <template v-for="(p, index) in ordine.ord" :key="index">
                                    <li v-if="index > 0 && p.ordine !== ordine.ord[index-1].ordine" class="list-group-item p-0" style="border:none;">
                                        <hr style="margin: 5px 0; border-top: 2px solid #ccc;">
                                    </li>
                                    <li class="m" style="display: flex; justify-content: space-between; align-items: center;">
                                        <div style="flex: 1;">
                                            {{p.quantita}}:{{p.piatto}} 
                                            {{formatAggiunte(p.aggiunta) ? ` + ${formatAggiunte(p.aggiunta)}` : ''}}
                                            {{formatSenza(p.senza) ? ` - ${formatSenza(p.senza)}` : ''}}
                                            <div v-if="p.nota" style="font-style: italic; font-size: 0.85em; color: #7f8c8d;">{{ $t('nota', 'Nota') }}: {{p.nota}}</div>
                                            , €:{{(p.costoAggiunta ? p.costoAggiunta + p.prezzo : p.prezzo).toFixed(2)}}
                                        </div>
                                        <button 
                                            type="button" 
                                            class="btn btn-outline-danger btn-sm p-1 ms-2" 
                                            @click.prevent="() => rimuoviPiattoDalTavolo(ordine.idO, p.piattoId || p._id)"
                                            title="Elimina questo piatto"
                                            style="width: 28px; height: 28px; display: inline-flex; align-items: center; justify-content: center; border-radius: 6px; flex-shrink: 0;"
                                        >
                                            <i class="fas fa-trash-alt" style="font-size: 11px;"></i>
                                        </button>
                                    </li>
                                </template>
                                <li>{{ $t('totale') }}: {{totale}}</li>
                                <div style="display: flex; flex-wrap: wrap; gap: 10px; margin-top: 10px;">
                                    <a href="#" class="btn btn-outline-primary btn-sm" @click.prevent="() => aggiungiPiatti(ordine.t)">{{ $t('aggiungi_piatti', 'Aggiungi Piatti') }}</a>
                                    
                                    <a v-if="getActiveAdv(ordine)" 
                                       href="#" 
                                       class="btn btn-outline-info btn-sm" 
                                       @click.prevent="() => segnaComeServito(ordine, getActiveAdv(ordine).portata)"
                                    >
                                       {{getActiveAdv(ordine).portata}}° Servito
                                    </a>

                                    <a v-else-if="getNextPortata(ordine)" 
                                       href="#" 
                                       class="btn btn-outline-warning btn-sm" 
                                       @click.prevent="() => confermaAvanzamentoManuale(ordine, getNextPortata(ordine))"
                                    >
                                       Manda in Marcia {{getNextPortata(ordine)}}°
                                    </a>

                                    <a href="#" class="btn btn-outline-success btn-sm" @click.prevent="() => chiudiTavolo(ordine.idT,ordine.idO)">{{ $t('chiudi_tavolo') }}</a>
                                    <button type="button" class="btn btn-outline-danger btn-sm" @click.prevent="() => eliminaTavolo(ordine.idT, ordine.idO)">
                                        <i class="fas fa-ban me-1"></i> Elimina Tavolo
                                    </button>
                                    <a href="#" class="btn btn-outline-info btn-sm" @click.prevent="() => generaPagamentoStripe(ordine.idT, ordine.idO)">Genera Pagamento</a>
                                </div>
                            </ul>
                        </div>
                    </div>
                </div>
                <div class="pano-pren" v-show="tab.prenT">
                    <div class="card">
                        <div>
                            <ul class="list-group list-group-flush" v-for="prenotazioni in prenotazionisala" :key="prenotazioni._id">
                                <div v-if="prenotazioni.numero == tavolo || prenotazioni.numero == 't' + tavolo">
                                    <li class="list-group-item m tavolo-pre d-flex justify-content-between align-items-center">
                                        <span>Tavolo: {{prenotazioni.numero}}</span>
                                        <span class="badge" :class="prenotazioni.stato === 'arrivato' ? 'bg-success' : (prenotazioni.stato === 'annullata' ? 'bg-danger' : 'bg-primary')">
                                            {{ prenotazioni.stato === 'arrivato' ? 'ARRIVATO' : (prenotazioni.stato === 'annullata' ? 'ANNULLATA' : 'CONFERMATA') }}
                                        </span>
                                    </li>
                                    <li class="list-group-item m">Nome: {{prenotazioni.nome}} {{prenotazioni.cognome}}</li>
                                    <li class="list-group-item m">Telefono: {{prenotazioni.telefono}}</li>
                                    <li class="list-group-item m">Coperti: {{prenotazioni.coperti}}</li>
                                    <li class="list-group-item m">Orario: {{moment.unix(prenotazioni.tm).format('h:mm A')}}</li>
                                    <li class="list-group-item m p-2 d-flex gap-1 flex-wrap">
                                        <button v-if="prenotazioni.stato !== 'arrivato' && prenotazioni.stato !== 'annullata'" class="btn btn-sm btn-success py-0 px-2" @click="confermaArrivoBooking(prenotazioni)">
                                            <i class="fas fa-check me-1"></i>Arrivato
                                        </button>
                                        <button class="btn btn-sm btn-outline-primary py-0 px-2" @click="apriModificaBooking(prenotazioni)">
                                            <i class="fas fa-edit me-1"></i>Modifica
                                        </button>
                                        <button v-if="prenotazioni.stato !== 'annullata'" class="btn btn-sm btn-outline-warning py-0 px-2" @click="annullaBooking(prenotazioni)">
                                            <i class="fas fa-times me-1"></i>Annulla
                                        </button>
                                    </li>
                                    <hr>
                                </div>
                            </ul>
                        </div>
                    </div>
                </div>
                <div class="pano-pren" v-show="tab.prenotazioni">
                    <div class="card">
                        <div>
                            <ul class="list-group list-group-flush" v-for="prenotazioni in prenotazionisala" :key="prenotazioni._id">
                                <li class="list-group-item m tavolo-pre d-flex justify-content-between align-items-center">
                                    <span>Tavolo: {{prenotazioni.numero}}</span>
                                    <span class="badge" :class="prenotazioni.stato === 'arrivato' ? 'bg-success' : (prenotazioni.stato === 'annullata' ? 'bg-danger' : 'bg-primary')">
                                        {{ prenotazioni.stato === 'arrivato' ? 'ARRIVATO' : (prenotazioni.stato === 'annullata' ? 'ANNULLATA' : 'CONFERMATA') }}
                                    </span>
                                </li>
                                <li class="list-group-item m">Nome: {{prenotazioni.nome}} {{prenotazioni.cognome}}</li>
                                <li class="list-group-item m">Telefono: {{prenotazioni.telefono}}</li>
                                <li class="list-group-item m">Coperti: {{prenotazioni.coperti}}</li>
                                <li class="list-group-item m">Orario: {{moment.unix(prenotazioni.tm).format('h:mm A')}}</li>
                                <li class="list-group-item m p-2 d-flex gap-1 flex-wrap">
                                    <button v-if="prenotazioni.stato !== 'arrivato' && prenotazioni.stato !== 'annullata'" class="btn btn-sm btn-success py-0 px-2" @click="confermaArrivoBooking(prenotazioni)">
                                        <i class="fas fa-check me-1"></i>Arrivato
                                    </button>
                                    <button class="btn btn-sm btn-outline-primary py-0 px-2" @click="apriModificaBooking(prenotazioni)">
                                        <i class="fas fa-edit me-1"></i>Modifica
                                    </button>
                                    <button v-if="prenotazioni.stato !== 'annullata'" class="btn btn-sm btn-outline-warning py-0 px-2" @click="annullaBooking(prenotazioni)">
                                        <i class="fas fa-times me-1"></i>Annulla
                                    </button>
                                </li>
                                <hr>
                            </ul>
                        </div>
                    </div>
                </div>   
            </div>
            <div class="pren notifications-column side-column">
                <div class="notif-section mb-4" v-if="ritardiMarcia.length">
                    <h5 class="notif-title text-danger mb-3">⚠️ {{ $t('ritardi_marcia', 'Ritardi Marcia') }}</h5>
                    <ul class="list-group list-group-flush">
                        <li class="list-group-item d-flex justify-content-between align-items-center bg-transparent border-bottom px-0" v-for="m in ritardiMarcia" :key="m.idAdv">
                            <span class="small font-weight-bold">{{ $t('tavolo') }} {{ m.tavolo }} ({{ m.sala }})</span>
                            <span class="badge badge-danger badge-pill">{{ Math.floor(m.ritardoSecs / 60) }} min</span>
                        </li>
                    </ul>
                </div>

                <div class="notif-section mb-4" v-if="asportoNotifications.length">
                    <h5 class="notif-title text-primary mb-3">📦 {{ $t('nuovi_asporto', 'Nuovi Asporto') }}</h5>
                    <ul class="list-group list-group-flush">
                        <li class="list-group-item d-flex justify-content-between align-items-center bg-transparent border-bottom px-0" v-for="o in asportoNotifications" :key="o._id">
                            <span class="small font-weight-bold">{{ o.nome }}</span>
                            <div class="text-right">
                                <div class="badge badge-primary badge-pill d-block">{{ o.oraRitiro }}</div>
                            </div>
                        </li>
                    </ul>
                </div>

                <div class="notif-section mb-4" v-if="chiamateCameriere.length">
                    <h5 class="notif-title text-warning mb-3">🔔 {{ $t('chiamate', 'Chiamate') }}</h5>
                    <ul class="list-group list-group-flush">
                        <li class="list-group-item d-flex justify-content-between align-items-center bg-transparent border-bottom px-0" v-for="(c, idx) in chiamateCameriere" :key="idx">
                            <span class="small font-weight-bold">{{ $t('tavolo') }} {{ c.tavolo }} ({{ c.sala }})</span>
                            <button class="btn btn-xs btn-outline-warning py-0 px-2" @click="() => apriEvadiChiamata(c)">Evadi</button>
                        </li>
                    </ul>
                </div>

                <div v-if="!ritardiMarcia.length && !asportoNotifications.length && !chiamateCameriere.length" class="text-center py-5">
                    <i class="fas fa-bell-slash text-muted d-block mb-2" style="font-size: 2rem;"></i>
                    <p class="text-muted small italic">{{ $t('nessuna_notifica', 'Nessuna notifica') }}</p>
                </div>
            </div>
        </div>
    </div>
    <div class="nav-sale">
        <div>{{sala}}</div>
        <div class="con-sal">
            <ul class="nav nav-tabs" v-for="(sal, index) in sale" :key="sal">
                <li class="nav-item">
                    <span class="nav-link active" :id="sal.nome" @click="() => cambiaSala(sal,numeroSale[index])">{{sal}}</span>
                </li>
            </ul>
            <a href="#" class="btn btn-outline-success btn-sm home" @click.prevent="home">{{ $t('home') }}</a>
            <button 
                class="btn btn-sm lista-prenotati-btn" 
                :class="unassociatedCount > 0 ? 'btn-danger' : 'btn-success'"
                @click="openPrenotatiModal"
            >
                {{ $t('lista_prenotati') }}
            </button>
            <button 
                class="btn btn-sm btn-primary asporto-btn ml-2" 
                @click="goToAsportoStaff"
            >
                {{ $t('client_asporto') }}
            </button>
            <button 
                class="btn btn-sm btn-outline-info ml-2" 
                @click="tavolo = ''"
            >
                Focus Sala
            </button>
        </div>
    </div>
    <div class="modalita-switch-container">
        <div class="switch-wrapper">
            <button 
                :class="['switch-btn', { active: modalitaServizio === 'preparazione' }]" 
                @click="changeMode('preparazione')"
            >
                <i class="fas fa-tools mr-1"></i> Preparazione
            </button>
            <button 
                :class="['switch-btn', { active: modalitaServizio === 'servizio' }]" 
                @click="changeMode('servizio')"
            >
                <i class="fas fa-utensils mr-1"></i> Servizio
            </button>
        </div>
    </div>

    <!-- Banner Ordini Precedenti Aperti in questa sala -->
    <div v-if="ordiniPrecedentiSala.length > 0" class="ordini-precedenti-sala-alert">
        <div class="d-flex align-items-center gap-3">
            <div class="alert-icon-circle">
                <i class="fas fa-exclamation-triangle"></i>
            </div>
            <div>
                <strong class="alert-sala-title">Attenzione: Rilevati {{ ordiniPrecedentiSala.length }} ordini aperti dai giorni precedenti</strong>
                <div class="alert-sala-subtitle">I tavoli {{ getPrecedentiTableNames() }} hanno ordinazioni non ancora chiuse. Clicca sul tavolo o gestiscili subito.</div>
            </div>
        </div>
        <button type="button" class="sci-btn sci-btn-warning btn-sm" @click="showModalPrecedentiSala = true">
            <i class="fas fa-history me-1"></i> Gestisci Ordini ({{ ordiniPrecedentiSala.length }})
        </button>
    </div>

    <div class="visualizza-sala">
        <div class="tavolo" v-for="tavolo in tavoli" :key="tavolo">
            <span v-if="isTavoloPrecedente(tavolo)" class="badge-tavolo-ieri" title="Ordine rimasto aperto da un turno precedente">DA IERI</span>
            <img src="../assets/dinner-table.png" :id="tavolo" @click="selezionaTavolo" :class="{ 'tavolo-img-arrivato': isTavoloArrivato(tavolo) }">
            <span class="num-t"><b>T{{tavolo}}</b></span>
        </div>
    </div>

    <div class="coperti-modal-overlay" v-if="showModal">
        <div class="cont_conto" style="background-color: #2c3e50; border-radius: 12px; padding: 20px; color: white;">
            <div style="display: flex; justify-content: space-between; align-items: center; border-bottom: 1px solid #555; padding-bottom: 10px; margin-bottom: 20px;">
                <h3 class="modal__title" id="modal-title" style="margin: 0; background: none;">Bagni Fiore</h3>
                <span class="chiudi_modal" @click.prevent="showModal = false" style="background: #e74c3c; padding: 5px 15px; border-radius: 6px; cursor: pointer;">{{ $t('exit') || 'X' }}</span>
            </div>
            <div style="margin-bottom: 15px; display: flex; gap: 20px; align-items: center;">
                <span class="cameriere" style="font-weight: bold;">Cameriere: {{ $t('waiter_name') }}</span>
                <span class="applica_sconto">
                    Sconto (€): <input type="number" v-model.number="sconto" style="width: 80px; border-radius: 4px; padding: 4px 8px; border: 1px solid #ccc;" />
                </span>
                <span class="dividi_conto">
                    Dividi per: <input type="number" min="1" v-model.number="numeroDivisione" style="width: 60px; border-radius: 4px; padding: 4px 8px; border: 1px solid #ccc;" />
                </span>
            </div>
            <span class="lista_conto" v-for="(ordine, idx) in ordinazione" :key="idx">
                <span class="list-group-item m" style="color: black; font-weight: bold; margin-bottom: 10px; border-radius: 8px;">Tavolo: {{ordine.t}} | Giorno: {{ordine.tm}} | Coperti: {{ordine.coperti}}</span>
                <span class="m item_cont" v-for="(p, pidx) in ordine.ord" :key="pidx" style="border-bottom: 1px dashed #555; padding: 8px 0; display: flex; flex-direction: column;">
                    <div style="display: flex; justify-content: space-between; width: 100%; align-items: center;">
                        <span class="list_piatto" style="flex: 2;">{{p.quantita}}x {{p.piatto}}</span> 
                        <span class="list_aggiunta" style="flex: 2; color: #f39c12;">{{formatAggiunte(p.aggiunta) ? `+ ${formatAggiunte(p.aggiunta)}` : ''}}</span> 
                        <span class="list_prezzo" style="flex: 1; text-align: right;">€ {{(p.costoAggiunta ? p.costoAggiunta + p.prezzo : p.prezzo).toFixed(2)}}</span>
                        <button class="btn btn-sm btn-outline-danger" style="margin-left: 10px; padding: 2px 8px;" @click.prevent="rimuoviPiattoDalTavolo(ordine.idO, p._id)" title="Elimina piatto">
                            <i class="fas fa-trash-alt"></i>
                        </button>
                    </div>
                    <div v-if="formatSenza(p.senza)" style="color: #e74c3c; font-size: 0.9em; padding-left: 20px;">- {{formatSenza(p.senza)}}</div>
                    <div v-if="p.nota" style="font-style: italic; font-size: 0.9em; color: #7f8c8d; padding-left: 20px;">Nota: {{p.nota}}</div>
                </span>
                
                <div style="margin-top: 15px; background: rgba(255,255,255,0.1); padding: 10px; border-radius: 8px;">
                    <div style="display: flex; gap: 20px; align-items: center; margin-bottom: 10px;">
                        <label style="font-weight: bold; margin: 0;">Metodo Pagamento:</label>
                        <div class="form-check">
                            <input class="form-check-input" type="radio" v-model="metodoPagamento" value="contante" id="pagContante">
                            <label class="form-check-label" for="pagContante">Contanti</label>
                        </div>
                        <div class="form-check">
                            <input class="form-check-input" type="radio" v-model="metodoPagamento" value="digitale" id="pagDigitale">
                            <label class="form-check-label" for="pagDigitale">Digitale</label>
                        </div>
                    </div>
                    <div style="display: flex; align-items: center; gap: 10px;">
                        <label style="font-weight: bold; margin: 0;">Email:</label>
                        <input type="email" class="form-control form-control-sm" v-model="emailScontrino" placeholder="cliente@email.com" style="flex: 1; color: black;" />
                    </div>
                </div>
  
                <div style="margin-top: 20px; padding-top: 15px; border-top: 2px solid #555; text-align: right; font-size: 1.2rem;">
                    <span :class="[sconto ? 'sconto' : '']" style="margin-right: 15px;">{{ $t('totale') }}: € {{totale.toFixed(2)}}</span>
                    <span v-if="sconto" style="color: #2ecc71; font-weight: bold; margin-right: 15px;">Scontato: € {{(totale - sconto).toFixed(2)}}</span>
                    <div v-if="numeroDivisione > 1" style="margin-top: 10px; font-weight: bold; color: #3498db;">
                        Totale per persona ({{numeroDivisione}}): € {{((totale - sconto) / numeroDivisione).toFixed(2)}}
                    </div>
                </div>
                <div class="conto_btn" style="margin-top: 25px; display: flex; gap: 10px; justify-content: center; flex-wrap: wrap;">
                    <button class="btn btn-primary" @click.prevent="printPaper(ordine.idT,ordine.idO,'ricevuta',[...ordinazione])">{{ $t('receipt') || 'Ricevuta' }}</button>
                    <button class="btn btn-warning" @click.prevent="printPaper(ordine.idT,ordine.idO,'preconto', [...ordinazione])">{{ $t('pre_receipt') || 'Preconto' }}</button>
                    <button class="btn btn-success" @click.prevent="showFatturaModal = true">{{ $t('invoice') || 'Fattura' }}</button>
                    <button class="btn btn-info" @click.prevent="inviaScontrinoElettronico(ordine)">Scontrino Elettr.</button>
                    <button class="btn btn-danger" @click.prevent="confermaChiusuraTavolo(ordine.idT,ordine.idO)">{{ $t('chiudi_tavolo') || 'Chiudi Tavolo' }}</button>
                    <button class="btn btn-outline-danger" @click.prevent="eliminaTavolo(ordine.idT, ordine.idO)"><i class="fas fa-ban"></i> Elimina Tavolo</button>
                </div>
            </span>
            <span class="totale_conto"></span>
        </div>
    </div>

    <!-- Modal Fattura Elettronica -->
    <div class="coperti-modal-overlay" v-if="showFatturaModal">
        <div class="cont_conto" style="background-color: #2c3e50; border-radius: 12px; padding: 20px; color: white; width: 700px; max-width: 95vw;">
            <div style="display: flex; justify-content: space-between; align-items: center; border-bottom: 1px solid #555; padding-bottom: 10px; margin-bottom: 20px;">
                <h3 style="margin: 0; background: none;">Fattura Elettronica</h3>
                <span @click="showFatturaModal = false" style="background: #e74c3c; padding: 5px 15px; border-radius: 6px; cursor: pointer;">{{ $t('exit') || 'X' }}</span>
            </div>
            
            <div style="margin-bottom: 20px; position: relative;">
                <label>Cerca Cliente (Ragione Sociale o P.IVA):</label>
                <input type="text" v-model="searchTextCliente" @input="cercaCliente" placeholder="Inizia a scrivere..." class="form-control" style="color: black; background: white;" />
                <div v-if="clientiTrovati.length" style="position: absolute; top: 100%; left: 0; right: 0; background: white; color: black; z-index: 1000; border-radius: 0 0 8px 8px; box-shadow: 0 4px 10px rgba(0,0,0,0.3); max-height: 200px; overflow-y: auto;">
                    <div v-for="c in clientiTrovati" :key="c._id" @click="selezionaCliente(c)" style="padding: 10px; border-bottom: 1px solid #eee; cursor: pointer;">
                        <b>{{ c.ragioneSociale }}</b> - {{ c.partitaIva || c.codiceFiscale }}
                    </div>
                </div>
            </div>

            <div style="display: grid; grid-template-columns: 1fr 1fr; gap: 15px; margin-bottom: 20px;">
                <div style="grid-column: span 2;">
                    <label>Ragione Sociale *:</label>
                    <input type="text" v-model="clienteCorrente.ragioneSociale" class="form-control" style="color: black; background: white;" />
                </div>
                <div>
                    <label>Partita IVA:</label>
                    <input type="text" v-model="clienteCorrente.partitaIva" class="form-control" style="color: black; background: white;" />
                </div>
                <div>
                    <label>Codice Fiscale:</label>
                    <input type="text" v-model="clienteCorrente.codiceFiscale" class="form-control" style="color: black; background: white;" />
                </div>
                <div>
                    <label>Indirizzo *:</label>
                    <input type="text" v-model="clienteCorrente.indirizzo" class="form-control" style="color: black; background: white;" />
                </div>
                <div>
                    <label>CAP *:</label>
                    <input type="text" v-model="clienteCorrente.cap" class="form-control" style="color: black; background: white;" />
                </div>
                <div>
                    <label>Comune *:</label>
                    <input type="text" v-model="clienteCorrente.comune" class="form-control" style="color: black; background: white;" />
                </div>
                <div>
                    <label>Provincia (2 Lettere) *:</label>
                    <input type="text" v-model="clienteCorrente.provincia" maxlength="2" class="form-control" style="color: black; background: white;" />
                </div>
                <div>
                    <label>Codice Destinatario:</label>
                    <input type="text" v-model="clienteCorrente.codiceDestinatario" maxlength="7" class="form-control" style="color: black; background: white;" />
                </div>
                <div>
                    <label>PEC:</label>
                    <input type="text" v-model="clienteCorrente.pec" class="form-control" style="color: black; background: white;" />
                </div>
            </div>

            <div style="text-align: center;">
                <button class="btn btn-success btn-lg" @click="inviaFatturaElettronica" :disabled="loadingFattura">
                    {{ loadingFattura ? 'Invio in corso...' : 'Invia Fattura Elettronica' }}
                </button>
            </div>
        </div>
    </div>

    <div class="coperti-modal-overlay" v-if="showCopertiModal">
      <div class="coperti-modal-box">
        <h5>{{ $t('inserisci_coperti', 'Inserisci Coperti') }}</h5>
        <p>{{ $t('quanti_coperti', 'Quanti coperti per il tavolo') }} <b>{{tempTavolo}}</b>?</p>
        <input type="number" min="1" v-model.number="inputCoperti" class="form-control" :placeholder="$t('nr_coperti')" />
        <div style="display:flex; gap:10px; margin-top:15px; justify-content:flex-end;">
          <button class="btn btn-secondary btn-sm" @click="showCopertiModal = false">{{ $t('annulla', 'Annulla') }}</button>
          <button class="btn btn-success btn-sm" @click="confermaCoperti">{{ $t('conferma', 'Conferma') }}</button>
        </div>
      </div>
    </div>

    <div class="coperti-modal-overlay" v-if="showAvanzamentoModal">
      <div class="coperti-modal-box">
        <h5>Manda in Marcia Portata</h5>
        <p>Seleziona la portata da inviare in cucina per il tavolo <b>{{ordineSelezionato ? ordineSelezionato.t : ''}}</b>:</p>
        <div class="list-group">
          <button 
            v-for="p in portateDisponibili" 
            :key="p" 
            class="list-group-item list-group-item-action"
            @click="confermaAvanzamento(p)"
          >
            {{p}}° Portata
          </button>
        </div>
        <div style="display:flex; gap:10px; margin-top:15px; justify-content:flex-end;">
          <button class="btn btn-secondary btn-sm" @click="showAvanzamentoModal = false">Annulla</button>
        </div>
      </div>
    </div>

    <div class="coperti-modal-overlay" v-if="showEvadiModal">
      <div class="coperti-modal-box" style="text-align: center;">
        <h5 style="color: #e74c3c;">{{ $t('chiamata_cameriere') || 'Chiamata Cameriere' }}</h5>
        <p style="font-size: 1.2rem; margin: 20px 0;">{{ $t('chiamata_evasa') || 'Chiamata evasa?' }}</p>
        <div style="display:flex; gap:15px; justify-content:center; margin-top:20px;">
          <button class="btn btn-secondary" @click="showEvadiModal = false">{{ $t('no') || 'No' }}</button>
          <button class="btn btn-danger" @click="evadiChiamata">{{ $t('si') || 'Sì' }}</button>
        </div>
      </div>
    </div>

    <!-- Modal Gestione Prenotati del Giorno -->
    <div class="coperti-modal-overlay" v-if="showPrenotatiModal" style="z-index: 26000;">
      <div class="prenotati-modal-box" style="max-width: 1100px; width: 95vw;">
        <div class="modal-header d-flex justify-content-between align-items-center">
          <div>
            <h4 class="mb-1 fw-bold text-dark"><i class="fas fa-calendar-check text-primary me-2"></i>{{ $t('lista_prenotati') }} — {{ sala }}</h4>
            <small class="text-muted">Conferma l'arrivo dei clienti, modifica dettagli o orari, annulla o assegna tavoli in tempo reale.</small>
          </div>
          <button class="close-btn" @click="showPrenotatiModal = false">&times;</button>
        </div>

        <!-- Filter Chips -->
        <div class="d-flex align-items-center gap-2 my-3 px-2 flex-wrap">
          <span class="text-muted small fw-bold">Filtra:</span>
          <button 
            type="button" 
            class="btn btn-sm" 
            :class="filtroStatoPrenotazioni === 'tutte' ? 'btn-primary' : 'btn-outline-secondary'"
            @click="filtroStatoPrenotazioni = 'tutte'"
          >
            Tutte ({{ dailyBookings.length }})
          </button>
          <button 
            type="button" 
            class="btn btn-sm" 
            :class="filtroStatoPrenotazioni === 'in_attesa' ? 'btn-primary' : 'btn-outline-secondary'"
            @click="filtroStatoPrenotazioni = 'in_attesa'"
          >
            In Attesa ({{ countBookingsByStatus('in_attesa') }})
          </button>
          <button 
            type="button" 
            class="btn btn-sm" 
            :class="filtroStatoPrenotazioni === 'arrivato' ? 'btn-success' : 'btn-outline-success'"
            @click="filtroStatoPrenotazioni = 'arrivato'"
          >
            Arrivati ({{ countBookingsByStatus('arrivato') }})
          </button>
          <button 
            type="button" 
            class="btn btn-sm" 
            :class="filtroStatoPrenotazioni === 'annullata' ? 'btn-danger' : 'btn-outline-danger'"
            @click="filtroStatoPrenotazioni = 'annullata'"
          >
            Annullate ({{ countBookingsByStatus('annullata') }})
          </button>
        </div>

        <div class="modal-body p-0">
          <div v-if="filteredDailyBookings.length === 0" class="text-center py-5">
            <i class="fas fa-calendar-times text-muted fa-2x mb-2"></i>
            <p class="text-muted mb-0">Nessuna prenotazione presente per il filtro selezionato.</p>
          </div>
          <div class="table-responsive" v-else style="max-height: 60vh; overflow-y: auto;">
            <table class="table table-hover align-middle mb-0">
              <thead class="table-light sticky-top">
                <tr>
                  <th>Cliente</th>
                  <th>Telefono / Email</th>
                  <th>Coperti</th>
                  <th>Orario</th>
                  <th>Tavolo</th>
                  <th>Stato</th>
                  <th style="min-width: 230px;">Azioni</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="p in filteredDailyBookings" :key="p._id || p.id" :class="{ 'table-success-subtle': p.stato === 'arrivato', 'table-secondary text-muted': p.stato === 'annullata' }">
                  <td>
                    <strong>{{ p.nome }} {{ p.cognome }}</strong>
                    <div v-if="p.note" class="small text-warning text-truncate" style="max-width: 200px;" :title="p.note">
                      <i class="fas fa-sticky-note me-1"></i>{{ p.note }}
                    </div>
                  </td>
                  <td>
                    <div class="small fw-semibold">{{ p.telefono || '—' }}</div>
                    <div class="small text-muted" v-if="p.email">{{ p.email }}</div>
                  </td>
                  <td>
                    <span class="badge bg-light text-dark border">
                      <i class="fas fa-users me-1 text-primary"></i>{{ p.coperti || 1 }}
                    </span>
                  </td>
                  <td>
                    <span class="fw-bold">{{ formatBookingTime(p) }}</span>
                  </td>
                  <td>
                    <div class="d-flex align-items-center gap-1">
                      <select v-model="p.selectedTavolo" class="form-select form-select-sm" :disabled="p.stato === 'annullata'" style="width: 85px;">
                        <option value="">Nessuno</option>
                        <option v-for="t in tavoli" :key="t" :value="t">T{{ t }}</option>
                      </select>
                      <button v-if="!p.associato && p.selectedTavolo && p.stato !== 'annullata'" class="btn btn-sm btn-outline-primary p-1" @click="associaBooking(p)" title="Assegna tavolo">
                        <i class="fas fa-link"></i>
                      </button>
                    </div>
                  </td>
                  <td>
                    <span v-if="p.stato === 'arrivato'" class="badge bg-success">
                      <i class="fas fa-check-circle me-1"></i>ARRIVATO
                    </span>
                    <span v-else-if="p.stato === 'annullata'" class="badge bg-danger text-decoration-line-through">
                      <i class="fas fa-ban me-1"></i>ANNULLATA
                    </span>
                    <span v-else-if="p.associato" class="badge bg-primary">
                      <i class="fas fa-chair me-1"></i>T{{ cleanTableNum(p.selectedTavolo || p.numero) }}
                    </span>
                    <span v-else class="badge bg-warning text-dark">
                      <i class="fas fa-clock me-1"></i>IN ATTESA
                    </span>
                  </td>
                  <td>
                    <div class="d-flex align-items-center gap-1 flex-wrap">
                      <!-- 1. Conferma Arrivo -->
                      <button 
                        v-if="p.stato !== 'arrivato' && p.stato !== 'annullata'" 
                        type="button" 
                        class="btn btn-sm btn-success py-1 px-2"
                        @click="confermaArrivoBooking(p)"
                        title="Segna cliente come arrivato e accomodato"
                      >
                        <i class="fas fa-user-check me-1"></i>Arrivato
                      </button>
                      <span v-else-if="p.stato === 'arrivato'" class="badge bg-success-subtle text-success border border-success py-1 px-2">
                        <i class="fas fa-check me-1"></i>In Sala
                      </span>

                      <!-- 2. Modifica -->
                      <button 
                        type="button" 
                        class="btn btn-sm btn-outline-primary py-1 px-2"
                        @click="apriModificaBooking(p)"
                        title="Modifica dettagli prenotazione"
                      >
                        <i class="fas fa-edit me-1"></i>Modifica
                      </button>

                      <!-- 3. Annulla -->
                      <button 
                        v-if="p.stato !== 'annullata'" 
                        type="button" 
                        class="btn btn-sm btn-outline-warning py-1 px-2"
                        @click="annullaBooking(p)"
                        title="Annulla prenotazione e libera il tavolo"
                      >
                        <i class="fas fa-times me-1"></i>Annulla
                      </button>

                      <!-- 4. Elimina -->
                      <button 
                        type="button" 
                        class="btn btn-sm btn-outline-danger py-1 px-2"
                        @click="eliminaBooking(p._id)"
                        title="Elimina definitivamente"
                      >
                        <i class="fas fa-trash-alt"></i>
                      </button>
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>

    <!-- Modale Modifica Prenotazione -->
    <div class="coperti-modal-overlay" v-if="showModificaBookingModal" style="z-index: 28000;">
      <div class="coperti-modal-box" style="max-width: 520px; width: 95%;">
        <div class="d-flex justify-content-between align-items-center border-bottom pb-2 mb-3">
          <h5 class="mb-0 fw-bold"><i class="fas fa-edit text-primary me-2"></i>Modifica Prenotazione</h5>
          <button type="button" class="btn-close" @click="showModificaBookingModal = false"></button>
        </div>

        <div class="row g-2 text-start">
          <div class="col-6">
            <label class="form-label small fw-bold">Nome *</label>
            <input type="text" v-model="editBookingForm.nome" class="form-control form-control-sm" />
          </div>
          <div class="col-6">
            <label class="form-label small fw-bold">Cognome</label>
            <input type="text" v-model="editBookingForm.cognome" class="form-control form-control-sm" />
          </div>
          <div class="col-6">
            <label class="form-label small fw-bold">Telefono</label>
            <input type="text" v-model="editBookingForm.telefono" class="form-control form-control-sm" />
          </div>
          <div class="col-6">
            <label class="form-label small fw-bold">Coperti *</label>
            <input type="number" min="1" v-model.number="editBookingForm.coperti" class="form-control form-control-sm" />
          </div>
          <div class="col-6">
            <label class="form-label small fw-bold">Data *</label>
            <input type="date" v-model="editBookingForm.data" class="form-control form-control-sm" />
          </div>
          <div class="col-6">
            <label class="form-label small fw-bold">Ora *</label>
            <input type="time" v-model="editBookingForm.ora" class="form-control form-control-sm" />
          </div>
          <div class="col-6">
            <label class="form-label small fw-bold">Tavolo Assegnato</label>
            <select v-model="editBookingForm.selectedTavolo" class="form-select form-select-sm">
              <option value="">Nessun tavolo</option>
              <option v-for="t in tavoli" :key="t" :value="t">T{{ t }}</option>
            </select>
          </div>
          <div class="col-6">
            <label class="form-label small fw-bold">Stato</label>
            <select v-model="editBookingForm.stato" class="form-select form-select-sm">
              <option value="confermata">Confermata (In Attesa)</option>
              <option value="arrivato">Arrivato</option>
              <option value="annullata">Annullata</option>
            </select>
          </div>
          <div class="col-12">
            <label class="form-label small fw-bold">Note / Richieste Particolari</label>
            <textarea v-model="editBookingForm.note" rows="2" class="form-control form-control-sm" placeholder="Es. seggiolone, compleanno, allergie..."></textarea>
          </div>
        </div>

        <div class="d-flex justify-content-end gap-2 mt-4 pt-2 border-top">
          <button type="button" class="btn btn-secondary btn-sm" @click="showModificaBookingModal = false">Annulla</button>
          <button type="button" class="btn btn-primary btn-sm" @click="salvaModificaBooking">
            <i class="fas fa-save me-1"></i>Salva Modifiche
          </button>
        </div>
      </div>
    </div>

    <div class="coperti-modal-overlay" v-if="showBookingModal">
      <div class="coperti-modal-box">
        <h5>{{ $t('prenota_tavolo') }} - {{ $t('tavolo') }} {{tavolo}}</h5>
        
        <div class="input-group mb-3 mt-3">
            <div class="input-group-prepend">
                <span class="input-group-text">{{ $t('nome') }}</span>
            </div>
            <input v-model="nome" type="text" class="form-control" :placeholder="$t('nome')">
        </div>

        <div class="input-group mb-3">
            <div class="input-group-prepend">
                <span class="input-group-text">{{ $t('cognome') }}</span>
            </div>
            <input v-model="cognome" type="text" class="form-control" :placeholder="$t('cognome')">
        </div>

        <div class="input-group mb-3">
            <div class="input-group-prepend">
                <span class="input-group-text">{{ $t('telefono') }}</span>
            </div>
            <input v-model="telefono" type="text" class="form-control" :placeholder="$t('telefono')">
        </div>

        <div class="input-group mb-3">
            <div class="input-group-prepend">
                <span class="input-group-text">Email</span>
            </div>
            <input v-model="email" type="email" class="form-control" placeholder="Email">
        </div>

        <div class="input-group mb-3">
            <div class="input-group-prepend">
                <span class="input-group-text">{{ $t('coperti') }}</span>
            </div>
            <input v-model="coperti" type="text" class="form-control" :placeholder="$t('nr_coperti')">
        </div>

        <div style="display:flex; gap:10px; margin-top:20px; justify-content:flex-end;">
          <button class="btn btn-secondary btn-sm" @click="showBookingModal = false">{{ $t('annulla', 'Annulla') }}</button>
          <button class="btn btn-success btn-sm" @click="prenotaTavolo">{{ $t('conferma', 'Conferma') }}</button>
        </div>
      </div>
    </div>

    <!-- Password Prompt Custom Modal -->
    <div class="coperti-modal-overlay" v-if="passwordPrompt.show" style="z-index: 30000;">
        <div class="cont_conto" style="background-color: #2c3e50; border-radius: 12px; padding: 20px; color: white; width: 350px; margin: auto;">
            <div style="margin-bottom: 15px;">
                <label style="font-weight: bold; display: block; margin-bottom: 8px;">{{ passwordPrompt.message }}</label>
                <input type="password" class="form-control" v-model="passwordPrompt.inputPassword" @keyup.enter="confermaPasswordPrompt" style="color: black;" />
            </div>
            <div style="display: flex; gap: 10px; justify-content: flex-end;">
                <button class="btn btn-secondary" @click.prevent="annullaPasswordPrompt">Annulla</button>
                <button class="btn btn-danger" @click.prevent="confermaPasswordPrompt">Conferma</button>
            </div>
        </div>
    </div>

    <!-- Modal: Gestione Ordini Precedenti per questa Sala -->
    <div v-if="showModalPrecedentiSala" class="sci-modal-overlay" tabindex="-1" role="dialog" aria-modal="true" style="z-index: 25000;">
        <div class="sci-modal-card" style="max-width: 750px;">
            <div class="sci-modal-header">
                <div class="d-flex align-items-center gap-2">
                    <i class="fas fa-history text-warning fa-lg"></i>
                    <div>
                        <h4 class="mb-0 fw-bold">Ordini da Giorni Precedenti — {{ sala }}</h4>
                        <small class="text-muted">Gestisci o chiudi i tavoli rimasti aperti in questa sala</small>
                    </div>
                </div>
                <button type="button" class="btn-close-modal" @click="showModalPrecedentiSala = false">
                    <i class="fas fa-times"></i>
                </button>
            </div>
            <div class="sci-modal-body">
                <div v-if="ordiniPrecedentiSala.length === 0" class="text-center py-4">
                    <i class="fas fa-check-circle text-success fa-2x mb-2"></i>
                    <p class="mb-0">Nessun ordine aperto pendente da giorni precedenti.</p>
                </div>
                <div v-else class="d-flex flex-column gap-3">
                    <div v-for="ord in ordiniPrecedentiSala" :key="ord.idO || ord._id" class="p-3 border rounded bg-white shadow-sm">
                        <div class="d-flex justify-content-between align-items-center mb-2">
                            <div>
                                <span class="badge bg-dark me-2">Tavolo {{ cleanTableNum(ord.numero || ord.tavolo) }}</span>
                                <span class="badge bg-warning text-dark"><i class="fas fa-calendar-alt me-1"></i>{{ formatDateTime(ord.tm) }}</span>
                            </div>
                            <span class="fw-bold fs-5">€ {{ calcolaTotalePrecedente(ord).toFixed(2) }}</span>
                        </div>
                        <div class="small text-muted mb-2" v-if="ord.coperti">Coperti: {{ ord.coperti }}</div>
                        <ul class="list-unstyled mb-3 border-top pt-2">
                            <li v-for="(p, pIdx) in getOrdinazionePrecedente(ord)" :key="pIdx" class="d-flex justify-content-between align-items-center py-1 border-bottom">
                                <span>{{ p.quantita || 1 }}x {{ p.piatto || p.nome }}</span>
                                <div>
                                    <span class="me-3">€ {{ ((p.prezzo || 0) * (p.quantita || 1)).toFixed(2) }}</span>
                                    <button class="btn btn-outline-danger btn-sm p-1" style="line-height: 1;" @click="rimuoviPiattoDalTavolo(ord.idO || ord.idOrdine || ord.codicemenu || ord._id, p.piattoId || p._id)" title="Elimina piatto">
                                        <i class="fas fa-trash-alt"></i>
                                    </button>
                                </div>
                            </li>
                        </ul>
                        <div class="d-flex justify-content-end gap-2">
                            <button class="btn btn-outline-danger btn-sm" @click="eliminaTavolo(ord.idT || ord.idTavolo || ord.codiceTavolo, ord.idO || ord.idOrdine || ord.codicemenu || ord._id)">
                                <i class="fas fa-ban me-1"></i> Elimina Tavolo
                            </button>
                            <button class="btn btn-success btn-sm" @click="selezionaEChiudiTavolo(ord)">
                                <i class="fas fa-check me-1"></i> Chiudi Tavolo
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

</div>
</template>

<script>
import moment from 'moment'
import { io } from "socket.io-client"
import { store } from '../store/store.js'
const { ipcRenderer } = window.require ? window.require('electron') : { ipcRenderer: null };

export default {
    name: 'VisualizzaSala',
        data: function () {
            return {
                tavoli:[],
                tavolo:'',
                date: new Date(),
                sala: this.$route.params.nome,
                sale:this.$route.params.sale,
                numeroSale: this.$route.params.numeroSale,
                numero:this.$route.params.numero,
                ordiniPrecedentiSala: [],
                showModalPrecedentiSala: false,
                nome:'',
                cognome:'',
                telefono:'',
                email:'',
                moment:'', 
                coperti:'',
                modalitaServizio: localStorage.getItem('modalitaServizio') || 'servizio',
                ordinazione:[],
                prenotazioni:[],
                prodotti:[],
                bgActive:'#c7c2c2',
                bgInactive:'#ffffff',
                totale:'',
                tab:{
                    ordinazioni:false,
                    prenotazioni:false,
                    prenT:false
                },
                prenotazionisala:[],
                ordini:[],
                socket:io(process.env.VUE_APP_SOCKET_URL, { autoConnect: true }),
                store,
                showModal: false,
                sconto:0,
                numeroDivisione: 1,
                metodoPagamento: 'contante',
                emailScontrino: '',
                showCopertiModal: false,
                tempTavolo: '',
                inputCoperti: 1,
                showAvanzamentoModal: false,
                ordineSelezionato: null,
                portateDisponibili: [],
                chiamateCameriere: [],
                showEvadiModal: false,
                tavoloDaEvadere: null,
                showPrenotatiModal: false,
                dailyBookings: [],
                unassociatedCount: 0,
                filtroStatoPrenotazioni: 'tutte',
                recentArrivedTables: [],
                popupArrivato: null,
                popupArrivatoTimer: null,
                showModificaBookingModal: false,
                editBookingForm: {
                    id: '',
                    nome: '',
                    cognome: '',
                    telefono: '',
                    email: '',
                    coperti: 2,
                    data: '',
                    ora: '',
                    selectedTavolo: '',
                    codicesala: '',
                    note: '',
                    stato: 'confermata'
                },
                ritardiMarcia: [],
                asportoNotifications: [],
                notifInterval: null,
                costoCoperto: 0,
                showBookingModal: false,
                showFatturaModal: false,
                clienteCorrente: {
                    ragioneSociale: '',
                    partitaIva: '',
                    codiceFiscale: '',
                    indirizzo: '',
                    cap: '',
                    comune: '',
                    provincia: '',
                    codiceDestinatario: '0000000',
                    pec: ''
                },
                searchTextCliente: '',
                clientiTrovati: [],
                loadingFattura: false,
                passwordPrompt: {
                    show: false,
                    message: '',
                    inputPassword: '',
                    resolve: null,
                    reject: null
                }
            }

        },
    methods: {
        getSettings() {
            this.axios.get(this.store.path + 'impostazioni/69c90e57851daafaf559b837', {
                headers: { authorization: `Bearer ${JSON.parse(localStorage.token)}` }
            }).then(response => {
                const data = response.data;
                if (data && data.costoCoperto !== undefined) {
                    this.costoCoperto = data.costoCoperto;
                }
            }).catch(error => {
                console.error("Errore nel caricamento del costo coperto:", error);
            });
        },
        cercaCliente() {
            if (this.searchTextCliente.length < 3) {
                this.clientiTrovati = [];
                return;
            }
            this.axios.post(this.store.path + 'cliente/list', { search: this.searchTextCliente }, {
                headers: { authorization: `Bearer ${JSON.parse(localStorage.token)}` }
            }).then(response => {
                this.clientiTrovati = response.data;
            });
        },
        selezionaCliente(cliente) {
            this.clienteCorrente = { ...cliente };
            this.clientiTrovati = [];
            this.searchTextCliente = cliente.ragioneSociale;
        },
        async inviaFatturaElettronica() {
            if (!this.clienteCorrente.ragioneSociale || !this.clienteCorrente.indirizzo || !this.clienteCorrente.cap || !this.clienteCorrente.comune || !this.clienteCorrente.provincia) {
                alert("Compila tutti i campi obbligatori (*)");
                return;
            }

            this.loadingFattura = true;
            try {
                // 1. Salva/Aggiorna Cliente
                await this.axios.post(this.store.path + 'cliente/upsert', this.clienteCorrente, {
                    headers: { authorization: `Bearer ${JSON.parse(localStorage.token)}` }
                });

                // 2. Genera e Invia Fattura
                const response = await this.axios.post(this.store.path + 'fattura/generate', {
                    orderData: {
                        totale: this.totale,
                        ord: this.ordinazione[0]?.ord || [] // Adjust based on mymenu structure
                    },
                    cliente: this.clienteCorrente,
                    paymentType: this.metodoPagamento,
                    discount: this.sconto
                }, {
                    headers: { authorization: `Bearer ${JSON.parse(localStorage.token)}` }
                });

                if (response.data && response.data.errorCode === 0) {
                    alert("Fattura elettronica inviata con successo!");
                    const targetOrder = this.ordinazione[0];
                    if (targetOrder && targetOrder.idT && targetOrder.idO) {
                        this.pagaTavolo(targetOrder.idT, targetOrder.idO, 'fattura');
                    }
                    this.showFatturaModal = false;
                    this.showModal = false;
                } else {
                    alert("Errore nell'invio della fattura: " + (response.data.errorMessage || "Errore sconosciuto"));
                }
            } catch (error) {
                console.error("Errore Fattura:", error);
                alert("Errore nell'invio della fattura: " + (error.response?.data?.message || error.message));
            } finally {
                this.loadingFattura = false;
            }
        },
        displayProduct() {
            this.axios.post(this.store.path+'displayProduct',{headers:{
            authorization: `Bearer  ${JSON.parse(localStorage.token)}`}}).then((response) => {
            console.log(response.data.messaggio)
            if(response.data.messaggio){
                console.log('Prodotti caricati con successo')
            }else{console.log('Non è stato possibile caricare i prodotti')}
            response.data.messaggio.forEach(element => {
                  this.prodotti.push(element);
            });
            })
        },
        getTavoli(){
            let numeroTavoli = parseInt(this.numero,10);
            for (let i=1; i <= numeroTavoli; i++){
                    this.tavoli.push(i)
            }
        },
        getStato () {

        },
        printOrdine () {
            
        },
        home() {
            this.$router.push({ name: "Gestionale"})
        },
        showTab(e) {
            var tab = e.target.id;
            if (tab == 'prenotazioni') {
                this.tab.prenotazioni = true;
                this.tab.prenT= false;
                this.tab.ordinazioni = false;
            }
            if(tab== 'pren-t'){
                this.tab.prenT = true;
                this.tab.ordinazioni = false;
                this.tab.prenotazioni= false;
            }
            if(tab == 'ordini') {
                this.tab.ordinazioni = true;
                this.tab.prenT= false;
                this.tab.prenotazioni= false;
                this.displayOrdine();
            }
        },

        formatAggiunte(list) {
            if (!list || !list.length) return '';
            const names = list.map(a => {
                if (!a) return '';
                if (typeof a === 'string') return a;
                if (typeof a === 'object') return a.descrizione || a.nome || a.descrizio || '';
                return String(a);
            }).filter(Boolean);
            return names.join(', ');
        },
        formatSenza(list) {
            if (!list || !list.length) return '';
            const names = list.map(s => {
                if (!s) return '';
                if (typeof s === 'string') return s;
                if (typeof s === 'object') return s.descrizione || s.nome || s.descrizio || '';
                return String(s);
            }).filter(Boolean);
            return names.join(', ');
        },
        cleanTableNum(raw) {
            if (!raw) return '';
            let s = String(raw);
            return s.startsWith('t') ? s.slice(1) : s;
        },
        formatDateTime(tm) {
            if (!tm) return '';
            const m = moment.unix(tm);
            const startOfToday = moment().startOf('day');
            const startOfYesterday = moment().subtract(1, 'day').startOf('day');
            if (m.isBetween(startOfYesterday, startOfToday)) {
                return `Ieri, ore ${m.format('HH:mm')}`;
            } else if (m.isBefore(startOfYesterday)) {
                return `${m.format('DD/MM/YYYY')} (${m.format('HH:mm')})`;
            }
            return m.format('DD/MM/YYYY HH:mm');
        },
        calcolaTotalePrecedente(ord) {
            const dishes = this.getOrdinazionePrecedente(ord);
            let tot = 0;
            dishes.forEach(d => {
                const p = Number(d.prezzo || 0);
                const a = Number(d.costoAggiunta || 0);
                const q = Number(d.quantita || 1);
                tot += (p + a) * q;
            });
            return tot;
        },
        getOrdinazionePrecedente(ord) {
            if (ord.ordinazione && Array.isArray(ord.ordinazione)) return ord.ordinazione;
            if (ord.ordineDoc && ord.ordineDoc.ordinazione && Array.isArray(ord.ordineDoc.ordinazione)) {
                return ord.ordineDoc.ordinazione;
            }
            if (ord.ord && Array.isArray(ord.ord)) return ord.ord;
            return [];
        },
        isTavoloPrecedente(tavoloNum) {
            if (!this.ordiniPrecedentiSala || !this.ordiniPrecedentiSala.length) return false;
            const target = String(tavoloNum);
            return this.ordiniPrecedentiSala.some(o => {
                let num = String(o.numero || o.tavolo || '');
                if (num.startsWith('t')) num = num.slice(1);
                return num === target;
            });
        },
        isOrdinePrecedente(ordine) {
            if (!ordine) return false;
            const startOfToday = moment().startOf('day').unix();
            if (ordine.rawTm) return ordine.rawTm < startOfToday;
            return false;
        },
        getPrecedentiTableNames() {
            if (!this.ordiniPrecedentiSala) return '';
            return this.ordiniPrecedentiSala.map(o => {
                let n = String(o.numero || o.tavolo || '');
                return n.startsWith('t') ? n : 'T' + n;
            }).join(', ');
        },
        fetchOrdiniPrecedentiSala() {
            const storedToken = localStorage.token ? JSON.parse(localStorage.token) : '';
            const startOfToday = moment().startOf('day').unix();

            this.axios.post(this.store.path + 'getOrdiniApertiPrecedenti', { codicesala: this.sala }, {
                headers: { authorization: `Bearer ${storedToken}` }
            }).then(response => {
                if (response.data && response.data.messaggio) {
                    this.ordiniPrecedentiSala = response.data.messaggio;
                    this.applyOrdiniPrecedentiStyles();
                }
            }).catch(() => {
                this.axios.post(this.store.path + 'displayOrdini', {
                    codicesala: this.sala,
                    soloPrecedenti: true,
                    stato: 'ordinato',
                    end: startOfToday
                }, {
                    headers: { authorization: `Bearer ${storedToken}` }
                }).then(res => {
                    if (res.data && res.data.messaggio) {
                        this.ordiniPrecedentiSala = res.data.messaggio;
                        this.applyOrdiniPrecedentiStyles();
                    }
                }).catch(err => {
                    console.warn("Impossibile recuperare ordini precedenti sala:", err);
                });
            });
        },
        applyOrdiniPrecedentiStyles() {
            this.$nextTick(() => {
                this.tavoli.forEach(tav => {
                    const el = document.getElementById(`${tav}`);
                    if (el) el.classList.remove('ordinato-ieri');
                });
                if (this.ordiniPrecedentiSala && this.ordiniPrecedentiSala.length) {
                    this.ordiniPrecedentiSala.forEach(tav => {
                        let num = String(tav.numero || tav.tavolo);
                        if (num.startsWith('t')) num = num.slice(1);
                        const el = document.getElementById(`${num}`);
                        if (el) {
                            el.classList.add('ordinato');
                            el.classList.add('ordinato-ieri');
                        }
                    });
                }
            });
        },
        selezionaEChiudiTavolo(ord) {
            this.showModalPrecedentiSala = false;
            let tNum = String(ord.numero || ord.tavolo || '');
            if (tNum.startsWith('t')) tNum = tNum.slice(1);
            this.tavolo = tNum;
            this.tab.ordinazioni = true;
            this.displayOrdine(false, true);
            this.$nextTick(() => {
                this.chiudiTavolo(ord.idT || ord.codiceTavolo, ord.idO || ord._id);
            });
        },
        displayOrdine(printer, forceAnyDate = false){
            this.moment = moment;
            var end = forceAnyDate ? undefined : moment(this.date).endOf('day').unix();
            var start = forceAnyDate ? undefined : moment(this.date).startOf('day').unix();
            var data = moment(this.date).format('DD/MM HH:mm');
            var rv= [];
            var totale = 0;
            const reqPayload = { codtavolo: this.tavolo, sala: this.sala, singolo: true };
            if (!forceAnyDate) {
                reqPayload.end = end;
                reqPayload.start = start;
            }
            this.axios.post(this.store.path+'displayOrdine', reqPayload, {
                headers:{
                    authorization: `Bearer  ${JSON.parse(localStorage.token)}`
                }
            }).then((response) => {
                if(response.data){
                    response.data.messaggio.forEach(element => { 
                        console.log(element.ordine)
                        element.ordine.forEach(ord => {
                            let itemCostoAggiunta = 0;
                            if (ord.aggiunta && ord.aggiunta.length) {
                                ord.aggiunta.forEach(aggiunta => {
                                    if (typeof aggiunta === 'object' && aggiunta !== null) {
                                        if (aggiunta.prezzo !== undefined && aggiunta.prezzo !== null) {
                                            itemCostoAggiunta += Number(aggiunta.prezzo) || 0;
                                        } else {
                                            const desc = aggiunta.descrizione || aggiunta.nome || aggiunta.descrizio;
                                            const prod = this.prodotti.find(o => o.descrizio === desc || o.nome === desc);
                                            if (prod && prod.prezzoAggiunta) {
                                                itemCostoAggiunta += Number(prod.prezzoAggiunta) || 0;
                                            }
                                        }
                                    } else if (typeof aggiunta === 'string') {
                                        const prod = this.prodotti.find(o => o.descrizio === aggiunta || o.nome === aggiunta);
                                        if (prod && prod.prezzoAggiunta) {
                                            itemCostoAggiunta += Number(prod.prezzoAggiunta) || 0;
                                        }
                                    }
                                });
                            }
                            const qty = ord.quantita || 1;
                            ord.costoAggiunta = itemCostoAggiunta * qty;
                            totale = totale + (ord.costoAggiunta ? ord.costoAggiunta : 0) + ord.prezzo;
                        })
                        
                        if (this.costoCoperto > 0 && element.coperti > 0) {
                            element.ordine.push({
                                piatto: 'Coperto',
                                quantita: element.coperti,
                                prezzo: this.costoCoperto * element.coperti,
                                aggiunta: [],
                                senza: [],
                                ordine: '99',
                                nota: '',
                                costoAggiunta: 0
                            });
                            totale += (this.costoCoperto * element.coperti);
                        }
                            
                        rv.push({
                            idT: element.idTavolo,
                            idO: element.idOrdine,
                            t: element.tavolo,
                            ord: element.ordine,
                            tm: element.tm ? moment.unix(element.tm).format('DD/MM/YYYY HH:mm') : data,
                            rawTm: element.tm,
                            coperti: element.coperti,
                            avanzamento: element.avanzamento,
                            sala: this.sala
                        });
                        element.ordine.sort((a,b) => {
                            const getNum = (s) => parseInt(s) || 100;
                            return getNum(a.ordine) - getNum(b.ordine);
                        });
                    });
                    if(!printer){
                        this.totale = totale;
                        this.ordinazione= [...rv];
                        localStorage.setItem('ordinazioni', JSON.stringify(rv));
                        console.log('Ordine Presente Per Questa Data')
                    }else{
                        console.log('ciao')
                    }

                }else{console.log('Nessun Ordine Presente Per Questo Tavolo')}
            })

        },

        displayOrdini(){
            this.moment = moment;
            var end = moment(this.date).endOf('day').unix();
            var start = moment(this.date).startOf('day').unix();
            var rv= [];
            this.axios.post(this.store.path+'displayOrdini',{codicesala:this.sala,end:end,start:start,stato:'ordinato',headers:{
      authorization: `Bearer  ${JSON.parse(localStorage.token)}`}}).then((response) => {
                if(response.data){
                    console.log(response.data);
                    response.data.messaggio.forEach(function(el){
                        console.log(el);
                        rv.push(el);
                    })
                    this.ordini =rv;
                }else{console.log('Non è Stato Possibile Caricare gli Ordini')}
                this.fetchOrdiniPrecedentiSala();
            }).catch(() => {
                this.fetchOrdiniPrecedentiSala();
            })

        },
        pagaTavolo (idT,idO,tipo) {
            console.log(tipo)
            const isDigitale = this.metodoPagamento === 'digitale';
            this.axios.post(this.store.path+'chiudiOrdine',{
                idT: idT,
                idO: idO,
                totale: this.totale,
                sconto: this.sconto,
                digitale: isDigitale,
                headers:{
                    authorization: `Bearer  ${JSON.parse(localStorage.token)}`
                }
            }).then((response) => {
                if(response.data){
                    console.log(response.data)
                    this.ordinazione=[];
                    this.displayOrdini()
                    this.fetchOrdiniPrecedentiSala()
                    console.log('Ordine Presente Per Questa Data')
                }else{console.log('Nessun Ordine Presente Per Questo Tavolo')}
            })
        },
        printPaper(idT,idO,tipo,ordinazione) {
            console.log("entrato")
            console.log(ordinazione)
            var whereIcanPrint = []
            this.axios.post(this.store.path+'displaySpecificPrinter',{nome:'cassa',headers:{
            authorization: `Bearer  ${JSON.parse(localStorage.token)}`}})
            .then((response) => {
            if(response.data.messaggio){
                console.log(response.data.messaggio)
                response.data.messaggio.forEach(element => {
                    whereIcanPrint.push({id:element._id,nome:element.nome, ip:element.ip,porta:element.porta,postazioni:element.postazioni})
            });
            if(ordinazione.length && ipcRenderer){
                const sanitizedOrdinazione = JSON.parse(JSON.stringify(ordinazione));
                whereIcanPrint.forEach(element => {
                    ipcRenderer.send('print', sanitizedOrdinazione, { ip: element.ip, porta: element.porta }, 'cassa', this.sconto);
                });
            }
            }else{
                console.log('Non ci sono permessi da mostrare')
            }
            console.log('printPaper! end')
            if(tipo!='preconto'){
                this.pagaTavolo(idT,idO,tipo)
            }
            })
        },
        inviaScontrinoElettronico(ordine) {
            const data = {
                orderData: {
                    idO: ordine.idO,
                    t: ordine.t,
                    ord: ordine.ord,
                    totale: this.totale
                },
                paymentType: this.metodoPagamento,
                email: this.emailScontrino,
                discount: this.sconto
            };

            this.axios.post(this.store.path + 'scontrino/generate', data, {
                headers: { authorization: `Bearer ${JSON.parse(localStorage.token)}` }
            }).then(() => {
                alert("Scontrino elettronico inviato con successo!");
                this.pagaTavolo(ordine.idT, ordine.idO, 'scontrino');
                this.showModal = false;
            }).catch(error => {
                const msg = error.response?.data?.message || "Errore durante l'invio dello scontrino.";
                alert("Errore: " + msg);
            });
        },
        chiudiTavolo (idT,idO) {
            console.log(idT,idO)
            this.showModal = true
        },
        confermaChiusuraTavolo(idT, idO) {
            if (confirm("Sei sicuro di voler chiudere il tavolo?")) {
                this.pagaTavolo(idT, idO, 'chiusura');
                this.showModal = false;
            }
        },
        async verificaPasswordAdmin() {
            try {
                const responseSettings = await this.axios.get(this.store.path + 'impostazioni/69c90e57851daafaf559b837', {
                    headers: { authorization: `Bearer ${JSON.parse(localStorage.token)}` }
                });
                if (responseSettings.data && responseSettings.data.passwordAdmin) {
                    const passwordAdmin = responseSettings.data.passwordAdmin;
                    const input = await this.richiediPasswordAdmin("Inserisci la password amministratore per procedere:");
                    if (input === null) {
                        return { authorized: false };
                    }
                    if (input !== passwordAdmin) {
                        alert("Password amministratore errata!");
                        return { authorized: false };
                    }
                    return { authorized: true, password: input };
                }
                return { authorized: true, password: '' }; // Se non c'è una password impostata, consentiamo
            } catch (err) {
                console.error("Errore verifica password admin:", err);
                return { authorized: false };
            }
        },
        richiediPasswordAdmin(message = "Inserisci la password amministratore:") {
            return new Promise((resolve, reject) => {
                this.passwordPrompt.message = message;
                this.passwordPrompt.inputPassword = '';
                this.passwordPrompt.show = true;
                this.passwordPrompt.resolve = resolve;
                this.passwordPrompt.reject = reject;
            });
        },
        confermaPasswordPrompt() {
            if (this.passwordPrompt.resolve) {
                this.passwordPrompt.resolve(this.passwordPrompt.inputPassword);
            }
            this.passwordPrompt.show = false;
        },
        annullaPasswordPrompt() {
            if (this.passwordPrompt.resolve) {
                this.passwordPrompt.resolve(null);
            }
            this.passwordPrompt.show = false;
        },
        async rimuoviPiattoDalTavolo(idO, piattoId) {
            if (!piattoId) {
                alert("Non è possibile eliminare questo elemento.");
                return;
            }
            const authResult = await this.verificaPasswordAdmin();
            if (!authResult.authorized) return;

            this.axios.post(this.store.path + 'rimuoviPiattoDaOrdine', { 
                idOrdine: idO, 
                piattoId: piattoId,
                passwordAdmin: authResult.password
            }, {
                headers: { authorization: `Bearer ${JSON.parse(localStorage.token)}` }
            }).then(response => {
                if (response.data) {
                    alert("Piatto eliminato dal tavolo.");
                    this.displayOrdine(false, true);
                    this.fetchOrdiniPrecedentiSala();
                }
            }).catch(error => {
                console.error(error);
                alert("Errore durante l'eliminazione del piatto.");
            });
        },
        async eliminaTavolo(idT, idO) {
            const authResult = await this.verificaPasswordAdmin();
            if (!authResult.authorized) return;

            if (confirm("Sei sicuro di voler eliminare l'intero tavolo/ordine? Questa azione non può essere annullata.")) {
                this.axios.post(this.store.path + 'eliminaOrdine', { 
                    idOrdine: idO,
                    passwordAdmin: authResult.password
                }, {
                    headers: { authorization: `Bearer ${JSON.parse(localStorage.token)}` }
                }).then(response => {
                    if (response.data) {
                        alert("Tavolo eliminato.");
                        this.showModal = false;
                        this.showModalPrecedentiSala = false;
                        this.ordinazione = [];
                        this.displayOrdini();
                        this.fetchOrdiniPrecedentiSala();
                    }
                }).catch(error => {
                    console.error(error);
                    alert("Errore durante l'eliminazione del tavolo.");
                });
            }
        },
        selezionaTavolo(e) {
            this.ordinazione = [];
            console.log(e.target.id);
            console.log(this.date);
            this.tavolo=e.target.id;

            let clickedTableId = String(e.target.id);
            if (clickedTableId.startsWith('t')) clickedTableId = clickedTableId.slice(1);

            const hasChiamata = this.chiamateCameriere.some(c => {
                const sameSala = c.sala.trim().toLowerCase() === this.sala.trim().toLowerCase();
                let savedTableId = String(c.tavolo);
                if (savedTableId.startsWith('t')) savedTableId = savedTableId.slice(1);
                
                return sameSala && savedTableId === clickedTableId;
            });

            if (hasChiamata) {
                this.tavoloDaEvadere = e.target.id;
                this.showEvadiModal = true;
            }

            if (this.modalitaServizio === 'preparazione') {
                console.log("Modalità Preparazione: Mostro modale prenotazione tavolo");
                this.showBookingModal = true;
                this.tab.ordinazioni = false;
                this.tab.prenT = true;
                this.tab.prenotazioni = false;
            } else {
                console.log("Modalità Servizio");
                // Controlla se c'è un ordine aperto su questo tavolo per mostrarlo automaticamente
                let hasOrder = this.ordini.some(t => {
                    if (t.codicesala !== this.sala) return false;
                    let num = String(t.numero);
                    if (num.startsWith('t')) num = num.slice(1);
                    return num === clickedTableId;
                });

                let hasOrderPrecedente = this.ordiniPrecedentiSala.some(t => {
                    let num = String(t.numero || t.tavolo);
                    if (num.startsWith('t')) num = num.slice(1);
                    return num === clickedTableId;
                });

                if (hasOrder || hasOrderPrecedente) {
                    console.log("Tavolo con ordine aperto selezionato. Mostro la scheda ordinazioni.");
                    this.tab.ordinazioni = true;
                    this.tab.prenT = false;
                    this.tab.prenotazioni = false;
                    this.displayOrdine(false, hasOrderPrecedente);
                } else {
                    console.log("Tavolo senza ordine aperto selezionato. Reimposto coperti e chiedo coperti.");
                    this.coperti = '';
                    this.aggiungiPiatti(e.target.id);
                }
            }
        },
        apriEvadiChiamata(c) {
            this.tavoloDaEvadere = String(c.tavolo).startsWith('t') ? c.tavolo : `t${c.tavolo}`;
            this.showEvadiModal = true;
        },
        parseWaitTime(timeStr) {
            if (!timeStr) return 0;
            const parts = String(timeStr).split(':');
            if (parts.length !== 2) return 0;
            return parseInt(parts[0]) * 60 + parseInt(parts[1]);
        },
        fetchNotifications() {
            this.axios.post(this.store.path + 'displayMarcia', {
                headers: { authorization: `Bearer ${JSON.parse(localStorage.token)}` }
            }).then(response => {
                if (response.data && response.data.messaggio) {
                    const now = Date.now() / 1000;
                    this.ritardiMarcia = response.data.messaggio.map(m => {
                        const waitSecs = this.parseWaitTime(m.tempo_di_attesa);
                        const expectedEnd = Number(m.tm) + waitSecs;
                        const isLate = now > expectedEnd;
                        return { ...m, isLate, ritardoSecs: Math.floor(now - expectedEnd) };
                    }).filter(m => m.isLate);
                }
            }).catch(err => console.error("Error fetching marcia:", err));

            const today = new Date().toISOString().split('T')[0];
            this.axios.post(this.store.path + 'getOrdiniAsporto', {
                pagato: true,
                data: today,
                stato: 'pagato',
                headers: { authorization: `Bearer ${JSON.parse(localStorage.token)}` }
            }).then(response => {
                if (response.data && response.data.messaggio) {
                    this.asportoNotifications = response.data.messaggio;
                }
            }).catch(err => console.error("Error fetching asporto notif:", err));
        },
        evadiChiamata() {
            if (!this.tavoloDaEvadere) return;

            let targetId = String(this.tavoloDaEvadere);
            if (targetId.startsWith('t')) targetId = targetId.slice(1);
            
            this.chiamateCameriere = this.chiamateCameriere.filter(c => {
                const isDifferentSala = c.sala.trim().toLowerCase() !== this.sala.trim().toLowerCase();
                let savedId = String(c.tavolo);
                if (savedId.startsWith('t')) savedId = savedId.slice(1);
                
                return isDifferentSala || savedId !== targetId;
            });
            
            localStorage.setItem('chiamateCameriere', JSON.stringify(this.chiamateCameriere));
            
            const element = document.getElementById(`${this.tavoloDaEvadere}`);
            if (element) element.classList.remove("cameriere");
            
            this.showEvadiModal = false;
            
            this.socket.emit('evasioneChiamata', { sala: this.sala, tavolo: this.tavoloDaEvadere });

            this.tavoloDaEvadere = null;
        },
        applyCameriereStyles() {
            this.tavoli.forEach(tav => {
                const element = document.getElementById(`${tav}`);
                if (element) element.classList.remove("cameriere");
            });

            this.chiamateCameriere.forEach(c => {
                if (c.sala.trim().toLowerCase() === this.sala.trim().toLowerCase()) {
                    let tableId = c.tavolo;
                    if (typeof tableId === 'string' && tableId.startsWith('t')) {
                        tableId = tableId.slice(1);
                    }
                    const element = document.getElementById(`${tableId}`);
                    if (element) element.classList.add("cameriere");
                }
            });
        },
        prenotaTavolo() {
            this.moment = moment;
            var data = moment(this.date).unix();
            this.axios.post(this.store.path+'prenotaTavolo',{nome:this.nome,cognome:this.cognome,telefono:this.telefono,email:this.email,codicesala:this.sala,tavolo:this.tavolo,coperti:this.coperti,tm:data,stato:'prenotato',headers:{
      authorization: `Bearer  ${JSON.parse(localStorage.token)}`}}).then((response) => {
                if(response.data){
                    this.prenotazionisala.push({numero:this.tavolo})
                    this.socket.emit('nuovaPrenotazione', {
                        sala: this.sala,
                        codicesala: this.sala,
                        tavolo: 't' + this.tavolo,
                        tm: data * 1000,
                        data: moment(this.date).format('YYYY-MM-DD'),
                        ora: moment(this.date).format('HH:mm'),
                        coperti: this.coperti,
                        nome: this.nome,
                        cognome: this.cognome,
                        telefono: this.telefono
                    })
                    console.log(response.data.messaggio)
                    this.tavolo='';
                    this.nome='';
                    this.cognome='';
                    this.coperti='';
                    this.telefono='';
                    this.email='';
                    this.prenotazioni= [response.data.messaggio];
                    this.showBookingModal = false;
                    console.log('Tavolo Prenotato')
                }else{console.log('Non è Stato Possibile prenotare il Tavolo')}
            })

        },
        displayPrenotazioni() {
        var prenotazioni =[];
        this.moment = moment;
        var end = moment(this.date).endOf('day').unix();
        var start = moment(this.date).startOf('day').unix();
        //var data = moment(this.date).unix();
        console.log('la richiesta è inviata')
        this.axios.post(this.store.path+'displayPrenotazioni',{end:end,start:start,codicesala:this.sala,stato:'prenotato',headers:{
      authorization: `Bearer  ${JSON.parse(localStorage.token)}`}}).then((response) => {
            if(response.data){
                console.log(response.data);
                response.data.messaggio.forEach(function(el){
                    console.log(el);
                    prenotazioni.push(el);
                })
                this.prenotazionisala = prenotazioni;
            }else{console.log('Non è Stato Possibile prenotare il Tavolo')}
        })

    },
    cambiaSala (sala,numero) {
        this.tavoli=[];
        this.sala = sala;
        this.numero = numero;
        this.getTavoli();
        this.displayPrenotazioni();
        this.displayOrdini();
        // Applica i colori rossi caricati dal localStorage
        this.chiamateCameriere = JSON.parse(localStorage.getItem('chiamateCameriere')) || [];
        this.$nextTick(() => {
            this.applyCameriereStyles();
        });
    },
    goToAsportoStaff() {
        this.$router.push({ name: "OrdineAsporto", query: { mode: 'staff' } })
    },
    changeMode(mode) {
        this.modalitaServizio = mode;
        localStorage.setItem('modalitaServizio', mode);
    },
    aggiungiPiatti(tavoloNum) {
        if (!this.coperti || parseInt(this.coperti) <= 0) {
            this.tempTavolo = tavoloNum;
            this.inputCoperti = 1;
            this.showCopertiModal = true;
            return;
        }
        this.procediAggiungiPiatti(tavoloNum, this.coperti);
    },
    confermaCoperti() {
        if (!this.inputCoperti || this.inputCoperti <= 0) {
            alert('Inserisci un numero di coperti valido');
            return;
        }
        this.coperti = this.inputCoperti;
        this.showCopertiModal = false;
        this.procediAggiungiPiatti(this.tempTavolo, this.inputCoperti);
    },
    procediAggiungiPiatti(tavoloNum, coperti) {
        let tavoloStr = String(tavoloNum).startsWith('t') ? String(tavoloNum) : 't' + tavoloNum;
        let ordData = {
            sala: this.sala,
            tavolo: tavoloStr,
            coperti: coperti,
            numero: this.numero,
            sale: this.sale,
            numeroSale: this.numeroSale
        };
        localStorage.setItem('ordineAttuale', JSON.stringify(ordData));
        this.$router.push({ name: 'Menu' });
    },
    apriAvanzamentoModal(ordine) {
        this.ordineSelezionato = ordine;
        const tuttePortate = [2, 3, 4, 5, 6];
        this.portateDisponibili = tuttePortate.filter(num => {
            const label = `${num}° portata`;
            const labelShort = `${num}°`;
            // Deve esserci nel menu
            const presenteNelMenu = ordine.ord.some(p => p.ordine === label || p.ordine === labelShort);
            // Non deve essere già in marcia
            const giaInMarcia = ordine.avanzamento && ordine.avanzamento.some(a => a.portata === num);
            
            return presenteNelMenu && !giaInMarcia;
        });

        if (this.portateDisponibili.length === 0) {
            alert("Nessuna portata successiva da mandare in marcia.");
            return;
        }

        this.showAvanzamentoModal = true;
    },
    confermaAvanzamento(portataNum) {
        this.confermaAvanzamentoManuale(this.ordineSelezionato, portataNum);
        this.showAvanzamentoModal = false;
    },
    confermaAvanzamentoManuale(ordine, portataNum) {
        if (!confirm(`Sei sicuro di voler mandare in marcia la ${portataNum}° portata?`)) return;

        this.axios.post(this.store.path + 'avanzaPortata', {
            ordineId: ordine.idO,
            portata: portataNum,
            headers: { authorization: `Bearer ${JSON.parse(localStorage.token)}` }
        }).then((response) => {
            if (response.data) {
                alert(`Portata ${portataNum}° inviata in cucina. Tempo attesa: ${response.data.tempo_di_attesa}`);
                this.displayOrdine(); 
            }
        }).catch(err => {
            console.error("Errore avanzamento:", err);
            alert("Errore durante l'invio della portata.");
        });
    },
    getActiveAdv(ordine) {
        if (!ordine.avanzamento) return null;
        return ordine.avanzamento.find(a => a.stato_avanzamento === 'in_marcia');
    },
    getNextPortata(ordine) {
        const portateInOrdine = [1, 2, 3, 4, 5, 6].filter(num => {
            const label = `${num}° portata`;
            const labelShort = `${num}°`;
            return ordine.ord.some(p => p.ordine === label || p.ordine === labelShort);
        });

        // Trova l'ultima portata servita
        const servite = (ordine.avanzamento || [])
            .filter(a => a.stato_avanzamento === 'servito')
            .map(a => a.portata);
        
        const lastServita = servite.length ? Math.max(...servite) : 0;
        
        // La prossima è la prima in ordine che è maggiore di lastServita
        return portateInOrdine.find(num => num > lastServita);
    },
    haPortateDaAvanzare(ordine) {
        return !!this.getNextPortata(ordine);
    },
    segnaComeServito(ordine, portataNum) {
        const label = portataNum ? `${portataNum}° ` : '';
        if (!confirm(`Segnare come servita la ${label}portata?`)) return;

        this.axios.post(this.store.path + 'segnaPortataComeServita', {
            ordineId: ordine.idO,
            portata: portataNum,
            headers: { authorization: `Bearer ${JSON.parse(localStorage.token)}` }
        }).then((response) => {
            if (response.data) {
                alert("Portata segnata come servita.");
                this.displayOrdine();
            }
        }).catch(err => {
            console.error("Errore segna come servito:", err);
            alert("Errore durante l'aggiornamento dello stato.");
        });
    },
    generaPagamentoStripe(idT, idO) {
        if (!confirm("Vuoi generare un link di pagamento Stripe per questo tavolo?")) return;

        this.axios.post(this.store.path + 'creaSessionePagamentoTavolo', {
            idT: idT,
            idO: idO,
            headers: { authorization: `Bearer ${JSON.parse(localStorage.token)}` }
        }).then((response) => {
            if (response.data && response.data.sessionUrl) {
                // Redirect to Stripe checkout
                window.location.href = response.data.sessionUrl;
            } else {
                alert("Errore nella generazione del link di pagamento.");
            }
        }).catch(err => {
            console.error("Errore Stripe:", err);
            alert("Errore durante la creazione della sessione di pagamento.");
        });
    },
    fetchDailyStatus() {
        this.axios.get(this.store.path + 'prenotazioni-mgmt/stato-associazione', {
            headers: { authorization: `Bearer ${JSON.parse(localStorage.token)}` }
        }).then(res => {
            this.unassociatedCount = res.data.totali - res.data.associate;
        }).catch(err => console.error("Error fetching association status:", err));
    },
    openPrenotatiModal() {
        this.fetchDailyBookings();
        this.showPrenotatiModal = true;
    },
    fetchDailyBookings() {
        this.axios.get(this.store.path + 'prenotazioni-mgmt/giorno', {
            headers: { authorization: `Bearer ${JSON.parse(localStorage.token)}` }
        }).then(res => {
            this.dailyBookings = res.data.map(b => {
                let table = b.selectedTavolo;
                if (!table && b.numero) {
                    table = b.numero;
                    // Rimuovi eventuale prefisso 't' e converti in numero
                    if (typeof table === 'string' && table.startsWith('t')) {
                        table = table.slice(1);
                    }
                    table = parseInt(table);
                }
                return { ...b, selectedTavolo: table || '' };
            });
        }).catch(err => console.error("Error fetching daily bookings:", err));
    },
    associaBooking(booking) {
        if (!booking.selectedTavolo) return alert("Seleziona un tavolo");
        this.axios.post(this.store.path + 'prenotazioni-mgmt/associa', {
            bookingId: booking._id,
            numeroTavolo: booking.selectedTavolo,
            codicesala: this.sala
        }, {
            headers: { authorization: `Bearer ${JSON.parse(localStorage.token)}` }
        }).then(() => {
            this.fetchDailyBookings();
            this.fetchDailyStatus();
            this.displayPrenotazioni();
        }).catch(err => alert(err.response?.data?.message || "Errore associazione"));
    },
    eliminaBooking(id) {
        if (!confirm("Sei sicuro di voler eliminare questa prenotazione?")) return;
        this.axios.delete(this.store.path + `prenotazioni-mgmt/${id}`, {
            headers: { authorization: `Bearer ${JSON.parse(localStorage.token)}` }
        }).then(() => {
            this.fetchDailyBookings();
            this.fetchDailyStatus();
            this.displayPrenotazioni();
        }).catch(() => alert("Errore eliminazione"));
    },
    formatBookingTime(p) {
        if (!p) return '—';
        if (p.ora) return p.ora;
        if (p.tm) {
            const tmNum = Number(p.tm);
            return moment.unix(tmNum < 1e11 ? tmNum : tmNum / 1000).format('HH:mm');
        }
        return '—';
    },
    countBookingsByStatus(status) {
        if (!this.dailyBookings || !this.dailyBookings.length) return 0;
        if (status === 'in_attesa') {
            return this.dailyBookings.filter(b => b.stato !== 'arrivato' && b.stato !== 'annullata').length;
        } else if (status === 'arrivato') {
            return this.dailyBookings.filter(b => b.stato === 'arrivato').length;
        } else if (status === 'annullata') {
            return this.dailyBookings.filter(b => b.stato === 'annullata').length;
        }
        return this.dailyBookings.length;
    },
    triggerPopupArrivato(tavolo) {
        if (!tavolo) return;
        const cleanT = String(tavolo).startsWith('t') ? String(tavolo).slice(1) : String(tavolo);
        this.popupArrivato = {
            tavolo: cleanT
        };
        if (this.popupArrivatoTimer) {
            clearTimeout(this.popupArrivatoTimer);
        }
        this.popupArrivatoTimer = setTimeout(() => {
            this.popupArrivato = null;
        }, 3000);
    },
    isTavoloArrivato(tavolo) {
        const cleanT = String(tavolo).startsWith('t') ? String(tavolo).slice(1) : String(tavolo);
        const inDaily = (this.dailyBookings || []).some(b => {
            if (b.stato !== 'arrivato') return false;
            let bTable = String(b.selectedTavolo || b.numero || '');
            if (bTable.startsWith('t')) bTable = bTable.slice(1);
            return bTable === cleanT;
        });
        if (inDaily) return true;
        return (this.prenotazionisala || []).some(p => {
            if (p.stato !== 'arrivato') return false;
            let pTable = String(p.numero || '');
            if (pTable.startsWith('t')) pTable = pTable.slice(1);
            return pTable === cleanT;
        });
    },
    confermaArrivoBooking(booking) {
        const bookingId = booking._id || booking.id || booking.idO;
        const targetTable = booking.selectedTavolo || booking.numero || this.tavolo;
        this.axios.post(this.store.path + 'prenotazioni-mgmt/conferma-arrivo', {
            id: bookingId,
            numeroTavolo: targetTable,
            codicesala: this.sala
        }, {
            headers: { authorization: `Bearer ${JSON.parse(localStorage.token)}` }
        }).then(() => {
            booking.stato = 'arrivato';
            this.triggerPopupArrivato(targetTable);
            this.fetchDailyBookings();
            this.fetchDailyStatus();
            this.displayPrenotazioni();
        }).catch(err => {
            console.error("Errore conferma arrivo:", err);
            alert(err.response?.data?.message || "Errore nella conferma dell'arrivo");
        });
    },
    apriModificaBooking(booking) {
        const bookingId = booking._id || booking.id || booking.idO;
        let bDate = '';
        let bTime = '';
        if (booking.tm) {
            const tmNum = Number(booking.tm);
            const m = tmNum < 1e11 ? moment.unix(tmNum) : moment(tmNum);
            bDate = m.format('YYYY-MM-DD');
            bTime = m.format('HH:mm');
        } else {
            bDate = moment().format('YYYY-MM-DD');
            bTime = booking.ora || '13:00';
        }

        let tableNum = booking.selectedTavolo || booking.numero || '';
        if (typeof tableNum === 'string' && tableNum.startsWith('t')) {
            tableNum = tableNum.slice(1);
        }

        this.editBookingForm = {
            id: bookingId,
            nome: booking.nome || '',
            cognome: booking.cognome || '',
            telefono: booking.telefono || '',
            email: booking.email || '',
            coperti: Number(booking.coperti) || 2,
            data: bDate,
            ora: bTime,
            selectedTavolo: tableNum,
            codicesala: this.sala,
            note: booking.note || '',
            stato: booking.stato || 'confermata'
        };
        this.showModificaBookingModal = true;
    },
    salvaModificaBooking() {
        if (!this.editBookingForm.nome) return alert("Inserisci il nome del cliente");
        if (!this.editBookingForm.data || !this.editBookingForm.ora) return alert("Inserisci data e ora della prenotazione");

        this.axios.post(this.store.path + 'prenotazioni-mgmt/modifica', {
            id: this.editBookingForm.id,
            nome: this.editBookingForm.nome,
            cognome: this.editBookingForm.cognome,
            telefono: this.editBookingForm.telefono,
            email: this.editBookingForm.email,
            coperti: this.editBookingForm.coperti,
            data: this.editBookingForm.data,
            ora: this.editBookingForm.ora,
            numeroTavolo: this.editBookingForm.selectedTavolo,
            codicesala: this.editBookingForm.codicesala || this.sala,
            note: this.editBookingForm.note,
            stato: this.editBookingForm.stato
        }, {
            headers: { authorization: `Bearer ${JSON.parse(localStorage.token)}` }
        }).then(res => {
            alert(res.data?.message || "Prenotazione modificata con successo!");
            this.showModificaBookingModal = false;
            this.fetchDailyBookings();
            this.fetchDailyStatus();
            this.displayPrenotazioni();
        }).catch(err => {
            console.error("Errore modifica prenotazione:", err);
            alert(err.response?.data?.message || "Errore nella modifica della prenotazione");
        });
    },
    annullaBooking(booking) {
        const bookingId = booking._id || booking.id || booking.idO;
        const motivo = prompt("Motivo dell'annullamento (facoltativo):", "Richiesta cliente");
        if (motivo === null) return; // operatore ha premuto Annulla nel prompt

        this.axios.post(this.store.path + 'prenotazioni-mgmt/annulla', {
            id: bookingId,
            motivo: motivo
        }, {
            headers: { authorization: `Bearer ${JSON.parse(localStorage.token)}` }
        }).then(res => {
            alert(res.data?.message || "Prenotazione annullata!");
            booking.stato = 'annullata';
            booking.associato = false;
            this.fetchDailyBookings();
            this.fetchDailyStatus();
            this.displayPrenotazioni();
        }).catch(err => {
            console.error("Errore annullamento prenotazione:", err);
            alert(err.response?.data?.message || "Errore durante l'annullamento della prenotazione");
        });
    }
},

    computed : {
      filteredDailyBookings() {
          if (!this.dailyBookings) return [];
          if (this.filtroStatoPrenotazioni === 'in_attesa') {
              return this.dailyBookings.filter(b => b.stato !== 'arrivato' && b.stato !== 'annullata');
          } else if (this.filtroStatoPrenotazioni === 'arrivato') {
              return this.dailyBookings.filter(b => b.stato === 'arrivato');
          } else if (this.filtroStatoPrenotazioni === 'annullata') {
              return this.dailyBookings.filter(b => b.stato === 'annullata');
          }
          return this.dailyBookings;
      },
      aggiornaOrdine(){
          let data = this.date;
            return data;
        },
        aggiornaStatoT(){
            let prenotazioni = this.prenotazionisala;
            return prenotazioni;
        },
        aggiornaOrdineT(){
            let ordini = this.ordini;
            return ordini
        }
   },
    watch:{
      aggiornaOrdine:{
          deep:true,
          handler:function(val){
              if(val){
                  console.log(val);
                  this.displayPrenotazioni();
                  this.displayOrdini();
                  this.ordinazione="";
                } 
            }
        },
        aggiornaStatoT:{
            deep:true,
            handler:function(val){
                console.log(val.length)
                this.tavoli.forEach(tav => {
                        var element = document.getElementById(`${tav}`);
                        if (element) {
                            element.classList.remove('prenotato');
                            element.classList.remove('arrivato');
                        }
                    });
                if(val.length){
                    val.forEach(tav => {
                        let num = tav.numero;
                        if (typeof num === 'string' && num.startsWith('t')) {
                            num = num.slice(1);
                        }
                        var element = document.getElementById(`${num}`);
                        console.log(element)
                        if (element) {
                            if (tav.stato === 'prenotato') {
                                element.classList.add("prenotato");
                            }
                        }
                    });
                }
                
            }
        },
        aggiornaOrdineT:{
            deep:true,
            handler:function(val){
                this.tavoli.forEach(tav => {
                        var element = document.getElementById(`${tav}`);
                        if (element) element.classList.remove('ordinato')
                    });
                if(val.length){
                    val.forEach(tav => {
                        if(tav.codicesala== this.sala){
                            let num = tav.numero;
                            if (typeof num === 'string' && num.startsWith('t')) {
                                num = num.slice(1);
                            }
                            var element = document.getElementById(`${num}`);
                            console.log(element)
                            if (element) element.classList.add("ordinato");
                        }
                    });
                }
                
            }
        },
    },

    mounted() {
        this.displayProduct();
        this.fetchDailyStatus();

        // Carica chiamate cameriere salvate
        const savedCalls = localStorage.getItem('chiamateCameriere');
        if (savedCalls) {
            this.chiamateCameriere = JSON.parse(savedCalls);
            this.$nextTick(() => {
                this.applyCameriereStyles();
            });
        }

        this.socket.on('ricevutoOrdine',(messaggio) => {
            console.log("Socket: ricevutoOrdine", messaggio)
            if(this.sala == messaggio.sala){
                this.displayOrdine(true);
            }
        })

        this.socket.on('aggiornaPrenotazioniData', (messaggio) => {
            console.log("Socket: aggiornaPrenotazioniData", messaggio)
            
            //aspetta 100ms 
            setTimeout(() => {
                this.fetchDailyStatus();
                this.fetchDailyBookings();
            }, 100);
        })

        // socket prenotazione
        this.socket.on('ricevutaPrenotazione',(messaggio) => {
            console.log("Socket: ricevutaPrenotazione", messaggio)
            const targetSala = (messaggio.sala || messaggio.codicesala || '').trim().toLowerCase();
            const currentSala = (this.sala || '').trim().toLowerCase();
            if(!targetSala || targetSala === currentSala){
                if (messaggio.stato === 'arrivato' && messaggio.tavolo) {
                    this.triggerPopupArrivato(messaggio.tavolo);
                }
                this.displayOrdine(true);
                this.fetchDailyBookings();
                this.displayPrenotazioni();
            }
        })

        // socket cameriere chiamato
        this.socket.on('ricevutaChiamataCameriere',(messaggio) => {
            console.log("Socket: ricevutaChiamataCameriere", messaggio)
            const targetSala = messaggio.sala ? messaggio.sala.trim().toLowerCase() : '';
            const currentSala = this.sala ? this.sala.trim().toLowerCase() : '';

            // Salva nel localStorage a prescindere dalla sala attuale per persistenza globale
            const esisteGia = this.chiamateCameriere.some(c => 
                c.sala.trim().toLowerCase() === targetSala && 
                String(c.tavolo) === String(messaggio.tavolo)
            );

            if (!esisteGia) {
                this.chiamateCameriere.push({
                    sala: messaggio.sala,
                    tavolo: messaggio.tavolo
                });
                localStorage.setItem('chiamateCameriere', JSON.stringify(this.chiamateCameriere));
            }

            if(targetSala === currentSala){
                // Normalize tavolo ID: remove 't' prefix if it exists to match the numeric ID in the DOM
                let tableId = messaggio.tavolo;
                if (typeof tableId === 'string' && tableId.startsWith('t')) {
                    tableId = tableId.slice(1);
                }
                
                var element = document.getElementById(`${tableId}`);
                if (element) {
                    element.classList.add("cameriere");
                    console.log(`✅ Table ${tableId} turned red (cameriere class added)`);
                }
            }
        })

        // socket evasione chiamata cameriere
        this.socket.on('ricevutaEvasioneChiamata',(messaggio) => {
            console.log("Socket: ricevutaEvasioneChiamata", messaggio)
            const targetSala = messaggio.sala ? messaggio.sala.trim().toLowerCase() : '';
            const currentSala = this.sala ? this.sala.trim().toLowerCase() : '';
            
            let targetTableId = String(messaggio.tavolo);
            if (targetTableId.startsWith('t')) targetTableId = targetTableId.slice(1);

            this.chiamateCameriere = this.chiamateCameriere.filter(c => {
                const isDifferentSala = c.sala.trim().toLowerCase() !== targetSala;
                let savedId = String(c.tavolo);
                if (savedId.startsWith('t')) savedId = savedId.slice(1);
                
                return isDifferentSala || savedId !== targetTableId;
            });
            
            localStorage.setItem('chiamateCameriere', JSON.stringify(this.chiamateCameriere));

            if(targetSala === currentSala){
                // Rimuovi la classe visiva
                const element = document.getElementById(`${targetTableId}`);
                if (element) element.classList.remove("cameriere");
                console.log(`✅ Table ${targetTableId} restored (cameriere class removed via socket)`);
            }
        })
    },
    beforeMount() {
        console.log("VisualizzaSala beforeMount initial state - sala:", this.sala, "numero:", this.numero, "sale:", this.sale, "numeroSale:", this.numeroSale);
        // Ripristina il contesto della sala dal localStorage se i params della rotta sono assenti (es. navigazione di ritorno o refresh)
        let stored = localStorage.getItem('ordineAttuale');
        console.log("VisualizzaSala beforeMount stored:", stored);
        if (stored) {
            let parsed = JSON.parse(stored);
            if (!this.sala && parsed.sala) {
                this.sala = parsed.sala;
                console.log("Restored sala from localStorage:", this.sala);
            }
            if (!this.numero && parsed.numero) {
                this.numero = parsed.numero;
                console.log("Restored numero from localStorage:", this.numero);
            }
            if ((!this.sale || !this.sale.length) && parsed.sale) {
                this.sale = parsed.sale;
                console.log("Restored sale from localStorage:", this.sale);
            }
            if ((!this.numeroSale || !this.numeroSale.length) && parsed.numeroSale) {
                this.numeroSale = parsed.numeroSale;
                console.log("Restored numeroSale from localStorage:", this.numeroSale);
            }
        }

        // Se l'elenco delle sale non è ancora definito, caricalo come fallback dal server
        if (!this.sale || !this.sale.length || !this.numeroSale || !this.numeroSale.length) {
            console.log("Sale lists are empty. Fetching from API...");
            this.axios.post(this.store.path + 'displaySala', {
                headers: { authorization: `Bearer ${JSON.parse(localStorage.token)}` }
            }).then((response) => {
                if (response.data && response.data.messaggio) {
                    var rvnome = [];
                    var rvnumero = [];
                    response.data.messaggio.forEach(element => {
                        rvnome.push(element.nome);
                        rvnumero.push(element.numero);
                    });
                    this.sale = rvnome;
                    this.numeroSale = rvnumero;
                    console.log("Fetched sale fallback from API:", this.sale, this.numeroSale);
                }
            }).catch(err => console.error("Errore recupero sale:", err));
        }

        this.getSettings();
        this.displayProduct();
        this.getTavoli();
        this.displayPrenotazioni();
        this.displayOrdini();
        this.fetchNotifications();
        this.notifInterval = setInterval(this.fetchNotifications, 30000);
    },
    beforeUnmount() {
        if (this.notifInterval) clearInterval(this.notifInterval);
    },

}
</script>

<style scoped>
.visualizza-sala {
    background-color: white;
    padding: 30px 15px;
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(100px, 1fr));
    gap: 20px;
    justify-items: center;
}
.nav-sale {
    background-color: white;
    padding: 15px;
    margin-bottom: 20px;
    box-shadow: 0 2px 5px rgba(0,0,0,0.05);
}

.con-sal {
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    gap: 10px;
    align-items: center;
}

.tavolo {
    position: relative;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    text-align: center;
    width: 100%;
    max-width: 90px;
}

.tavolo img {
    display: block;
    margin: 0 auto;
    width: 64px;
    height: 64px;
    object-fit: contain;
    cursor: pointer;
    transition: transform 0.2s ease, filter 0.2s ease;
}

.tavolo:hover img {
    transform: scale(1.06);
}

.num-t {
    display: block;
    width: 100%;
    text-align: center;
    margin-top: 6px;
    color: #e91e63;
    font-size: 1.1rem;
    font-weight: 700;
    line-height: 1.2;
}

.container-calendar-main {
    width: 100%;
    max-width: 100%;
    margin: 0;
    padding: 20px;
}
.preno {
    display: flex;
    flex-direction: column;
    margin-top: 20px;
}

.input-group {
    width: 100% !important;
}

.cont-cal {
    justify-content: center;
    overflow-x: auto;
}

.cont-btn-pre {
    display: flex;
    flex-direction: column;
    justify-content: center;
    gap: 10px;
    margin-top: 10px;
}

.cont-btn-pre-2 {
    display: flex;
    flex-direction: row;
    justify-content: center;
    gap: 10px;
    margin-top: 10px;
}

.cont-info {
    display: flex;
    flex-wrap: nowrap;
    gap: 25px;
    justify-content: center;
    align-items: stretch;
}

.m {
    list-style: none;
}

.active {
    cursor: pointer;
}

.tavolo-pre {
    background-color: burlywood;
}

.pano-pren {
    width: 100%;
    margin-top: 15px;
}

.pren {
    flex: 1;
    min-width: 320px;
    background: white;
    padding: 25px;
    border-radius: 16px;
    box-shadow: 0 10px 30px rgba(0,0,0,0.08);
}

.side-column {
    max-width: 450px;
}

.middle-column {
    flex: 3;
    max-width: none;
}

.notifications-column {
    max-height: 85vh;
    overflow-y: auto;
    scrollbar-width: thin;
    scrollbar-color: #888 #f1f1f1;
}

.notifications-column::-webkit-scrollbar {
    width: 6px;
}

.notifications-column::-webkit-scrollbar-track {
    background: #f1f1f1;
    border-radius: 10px;
}

.notifications-column::-webkit-scrollbar-thumb {
    background: #888;
    border-radius: 10px;
}

.notifications-column::-webkit-scrollbar-thumb:hover {
    background: #555;
}

.card {
    max-height: 400px;
    overflow-y: auto;
    border: none;
    box-shadow: 0 4px 10px rgba(0,0,0,0.08);
    border-radius: 8px;
}

.prenotato {
   filter: invert(9%) sepia(100%) saturate(7197%) hue-rotate(241deg) brightness(103%) contrast(125%);
}

.ordinato {
    filter: invert(74%) sepia(53%) saturate(5417%) hue-rotate(73deg) brightness(112%) contrast(130%) !important;

}

.cameriere {
   filter: invert(40%) sepia(82%) saturate(6286%) hue-rotate(348deg) brightness(86%) contrast(141%) !important;
}

.home {
    line-height: 2.5 !important;
}

.con-sa {
    min-height: 100vh;
    padding-bottom: 50px;
}

@media (max-width: 1200px) {
    .cont-info {
        flex-wrap: wrap;
    }
    .middle-column {
        flex: 1 1 100%;
        order: -1;
    }
}

@media (max-width: 768px) {
    .cont-info {
        flex-direction: column;
    }
    .side-column {
        max-width: none;
    }
    
    .visualizza-sala {
        grid-template-columns: repeat(3, 1fr);
    }
}

@media (max-width: 480px) {
    .visualizza-sala {
        grid-template-columns: repeat(2, 1fr);
    }
}

#style-3::-webkit-scrollbar-track
{
  -webkit-box-shadow: inset 0 0 6px rgba(0,0,0,0.3);
  background-color: #F5F5F5;
}

#style-3::-webkit-scrollbar
{
  width: 6px;
  background-color: #F5F5F5;
}

#style-3::-webkit-scrollbar-thumb
{
  background-color: #000000;
}
.modal__title {
  font-size: 1.5rem;
  font-weight: 700;
  background-color: whitesmoke;
}
.cont_conto {
    width: 80vw;
    height: 90vh;
    display: flex;
    flex-direction: column;
    overflow-y: scroll;
    background: currentColor;
    margin:auto;
}
.lista_conto {
    display: flex;
    flex-direction: column;
    color:white;
}
.conto_btn {
    display:flex;
    flex-direction: row;
    justify-content: center;
    gap:20px;
}
.cameriere {
    color:white
}
.applica_sconto {
    color:white;
}

.chiudi_modal {
    align-self: flex-end;
    color:white;
    font-weight: bold;
    cursor: pointer;
    padding:10px;
}
.sconto {
    text-decoration-line: line-through;
}

.item_cont {
    display: flex;
    justify-content: space-evenly;
    width: 100%;
}
.list_piatto {
    flex-basis: 20%;
    display:flex;
    margin-left:10px;
}
.list_aggiunta {
    flex-basis: 60%;
}
.list_prezzo {
    flex-basis:20%;
}

.coperti-modal-overlay {
  position: fixed;
  top: 0; left: 0; right: 0; bottom: 0;
  background: rgba(0,0,0,0.5);
  z-index: 9999;
  display: flex;
  align-items: center;
  justify-content: center;
}

.coperti-modal-box {
  background: #fff;
  border-radius: 12px;
  padding: 30px;
  min-width: 320px;
  max-width: 400px;
  box-shadow: 0 8px 30px rgba(0,0,0,0.25);
}

.coperti-modal-box h5 {
  margin-bottom: 10px;
  font-weight: 700;
  color: #2c3e50;
}

.coperti-modal-box p {
  color: #555;
  margin-bottom: 15px;
}

.lista-prenotati-btn {
    margin-left: 10px;
    font-weight: bold;
    text-transform: uppercase;
}

.prenotati-modal-box {
  background: white;
  width: 90%;
  max-width: 1000px;
  border-radius: 12px;
  padding: 20px;
  box-shadow: 0 5px 15px rgba(0,0,0,0.3);
  max-height: 90vh;
  overflow-y: auto;
}

.modal-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-bottom: 1px solid #eee;
  padding-bottom: 10px;
  margin-bottom: 15px;
}

.close-btn {
  background: none;
  border: none;
  font-size: 1.5rem;
  cursor: pointer;
}

.table-sm td, .table-sm th {
  padding: 0.3rem;
  font-size: 0.9rem;
}

.text-success { color: #28a745; }
.text-danger { color: #dc3545; }

.modalita-switch-container {
    display: flex;
    justify-content: center;
    margin: 15px 0 20px 0;
}

.switch-wrapper {
    display: flex;
    background-color: #f1f3f5;
    border-radius: 30px;
    padding: 4px;
    box-shadow: inset 0 2px 4px rgba(0,0,0,0.06);
    border: 1px solid #e2e8f0;
}

.switch-btn {
    border: none;
    background: transparent;
    padding: 8px 24px;
    border-radius: 25px;
    font-weight: 600;
    font-size: 0.95rem;
    color: #4a5568;
    cursor: pointer;
    transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
    outline: none;
    display: flex;
    align-items: center;
    gap: 6px;
}

.switch-btn:hover {
    color: #1a202c;
}

.switch-btn.active {
    background-color: #3b82f6;
    color: #ffffff;
    box-shadow: 0 4px 6px -1px rgba(59, 130, 246, 0.2), 0 2px 4px -1px rgba(59, 130, 246, 0.1);
}

/* Stili Ordini Precedenti Sala */
.ordini-precedenti-sala-alert {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  padding: 12px 20px;
  background: #fffbeb;
  border: 1px solid #fde68a;
  border-left: 5px solid #d97706;
  border-radius: 12px;
  margin: 12px 20px 18px 20px;
  box-shadow: 0 4px 12px rgba(217, 119, 6, 0.12);
  animation: fadeIn 0.3s ease;
}

.alert-icon-circle {
  width: 40px;
  height: 40px;
  min-width: 40px;
  border-radius: 10px;
  background: #fef3c7;
  color: #d97706;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 18px;
}

.alert-sala-title {
  display: block;
  font-size: 15px;
  font-weight: 700;
  color: #92400e;
}

.alert-sala-subtitle {
  font-size: 13px;
  color: #78350f;
  margin-top: 2px;
}

.badge-tavolo-ieri {
  position: absolute;
  top: 4px;
  right: 4px;
  background: #d97706;
  color: #ffffff;
  font-size: 10px;
  font-weight: 800;
  padding: 2px 6px;
  border-radius: 6px;
  letter-spacing: 0.5px;
  z-index: 10;
  box-shadow: 0 2px 4px rgba(0,0,0,0.2);
  animation: pulse-badge 2s infinite;
}

@keyframes pulse-badge {
  0% { transform: scale(1); }
  50% { transform: scale(1.08); }
  100% { transform: scale(1); }
}

.ordinato-ieri {
  filter: drop-shadow(0 0 8px rgba(217, 119, 6, 0.8)) !important;
}

/* Modale Ordini Precedenti Sala */
.sci-modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background: rgba(15, 23, 42, 0.6);
  backdrop-filter: blur(8px);
  -webkit-backdrop-filter: blur(8px);
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 20px;
  box-sizing: border-box;
}

.sci-modal-card {
  background: #ffffff;
  border-radius: 20px;
  border: 1px solid rgba(226, 232, 240, 0.8);
  box-shadow: 0 25px 50px -12px rgba(15, 23, 42, 0.25);
  width: 100%;
  max-height: 90vh;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

.sci-modal-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 20px 24px;
  border-bottom: 1px solid #e2e8f0;
  background: #f8fafc;
}

.btn-close-modal {
  background: transparent;
  border: none;
  font-size: 18px;
  color: #64748b;
  cursor: pointer;
  padding: 8px;
  border-radius: 8px;
  transition: all 0.2s ease;
}

.btn-close-modal:hover {
  background: #e2e8f0;
  color: #0f172a;
}

.sci-modal-body {
  padding: 24px;
  overflow-y: auto;
  max-height: calc(90vh - 80px);
}

.badge-tavolo-arrivato {
  position: absolute;
  top: 4px;
  left: 4px;
  background: #059669;
  color: #ffffff;
  font-size: 10px;
  font-weight: 800;
  padding: 2px 6px;
  border-radius: 6px;
  letter-spacing: 0.5px;
  z-index: 10;
  box-shadow: 0 2px 4px rgba(0,0,0,0.2);
  animation: pulse-badge 2s infinite;
}

.tavolo-img-arrivato {
  filter: drop-shadow(0 0 10px rgba(16, 185, 129, 0.85));
}

.ordinato.tavolo-img-arrivato {
  filter: invert(74%) sepia(53%) saturate(5417%) hue-rotate(73deg) brightness(112%) contrast(130%) drop-shadow(0 0 10px rgba(16, 185, 129, 0.85)) !important;
}

.table-success-subtle {
  background-color: #f0fdf4 !important;
}

.badge-tavolo-arrivato-fixed {
  position: fixed;
  top: 14px;
  left: 14px;
  background: #059669;
  color: #ffffff;
  font-size: 11px;
  font-weight: 800;
  padding: 4px 10px;
  border-radius: 20px;
  letter-spacing: 0.5px;
  z-index: 99999;
  box-shadow: 0 4px 12px rgba(5, 150, 105, 0.4);
  animation: pulse-badge 1.5s infinite;
  display: flex;
  align-items: center;
  cursor: pointer;
}

.fade-enter-active, .fade-leave-active {
  transition: opacity 0.3s ease, transform 0.3s ease;
}
.fade-enter-from, .fade-leave-to {
  opacity: 0;
  transform: translateY(-8px);
}
</style>